import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import Goals from "./InvestSmart/Goals";
import RiskProfiler from "./InvestSmart/RiskProfile";
import SocialShare from "../../general/socials";
import { closePopup, openPopup } from "../../general/Modal/action";
import { MODALS } from "../../general/Modal/constants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Slider from "react-slick";
import { getTrendingFundData, getHomePageDataStatic, getHome } from "./action";
import { round } from "lodash";
import NoContent from "../../general/NoContent";
import { getRouting, formDataGenerator, getYoutubePosterImage } from "../../../../utils/common";
import {
  postSmallCase,
  postInvestDataETF,
  postSmallCaseID,
} from "../Product/actions";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import cookie from "react-cookies";
import { browserName } from 'react-device-detect';

const HomePageNew = (props) => {
  const {
    trendingFundData,
    getTrendingFundData,
    closePopup,
    openPopup,
    postSmallCase,
    postInvestDataETF,
    postSmallCaseID,
    getHomePageDataStatic,
    homepageData,
    getHome,
    home,
  } = props;

  const tabs = [
    {
      label: "Tab 1",
      title: "Website",
      description:
        "<p>HDFC MFOnline Investor Portal offers folio management at pan-level, secure transactions 24x7, E-KYC, statement downloads.</p>",
      buttonName: "Register Now",
      quickLink:
        "https://investor-web.hdfcfund.com/new-investor/kyc-verification?_gl=1*1982ciq*_gcl_au*MTIyNzc3MzA4MC4xNjk4NzQ0NzEx",
        image: "/images/New/Homepagestatic/quick-invest/desktop/quick-invest1.webp",
        image2: "/images/New/Homepagestatic/quick-invest/mobile/quick-invest1-mob.webp",
      alt: "investfig",
      content: "Content for Tab 1",
    },
    {
      label: "Tab 2",
      title: "App",
      description:
        "<p>Want to invest on the Go?</p> <p>With the HDFC MFOnline Investor App, enjoy secure transactions with biometric authentication and access online services like E-KYC, statement downloads.</p>",
      buttonName: "Download Now",
      quickLink: "https://investor-web.hdfcfund.com/",
      image: "/images/New/Homepagestatic/quick-invest/desktop/quick-invest2.webp",
      image2: "/images/New/Homepagestatic/quick-invest/mobile/quick-invest2-mob.webp",
      alt: "investfig",
      content: "Content for Tab 2",
    },
    {
      label: "Tab 3",
      title: "Call",
      description:
        "<p>Connect with us instantly!</p><p>You can initiate transactions by calling the toll-free numbers for lumpsum/purchase, SIP registration, switch, and redemption. </p>",
      buttonName: "Call Now",
      quickLink: "tel:180030106767",
      image: "/images/New/Homepagestatic/quick-invest/desktop/quick-invest3.webp",
      image2: "/images/New/Homepagestatic/quick-invest/mobile/quick-invest3-mob.webp",
      alt: "investfig",
      content: "Content for Tab 3",
    },
    // {
    //   label: "Tab 4",
    //   title: "WhatsApp",
    //   description:
    //     "<p>WhatsApp Fan? Just say Hi to invest.</p><p>Initiate transactions, including lumpsum/purchase, SIP investment, requesting an account statement, updating contact details, and checking status. </p>",
    //   buttonName: "Transact Now",
    //   quickLink:
    //     "https://api.whatsapp.com/send/?phone=8270682706&text=Hi&app_absent=0",
    //     image: "/images/New/Homepagestatic/quick-invest/desktop/quick-invest4.webp",
    //     image2: "/images/New/Homepagestatic/quick-invest/mobile/quick-invest4-mob.webp",
    //   alt: "investfig",
    //   content: "Content for Tab 4",
    // },
  ];

  const heroBanner = [
    {
      slug : "/product-solutions/overview/hdfc-balanced-advantage-fund/direct",
      image: "/images/New/Homepagestatic/banner/banner-1.webp",
      alt:"balanced advantage fund",
    },
    {
      slug : "/product-solutions/overview/hdfc-flexi-cap-fund/direct",
      image: "/images/New/Homepagestatic/banner/banner-2.webp",
      alt:"flexi cap fund",
    },
    {
      slug : "/product-solutions/overview/hdfc-top-100-fund/direct",
      image: "/images/New/Homepagestatic/banner/banner-3.webp",
      alt:"top 100 fund",
    },
  ];

  const { location, history } = props;
  // const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [share, setShare] = useState(false);
  const [cardId, setCardId] = useState(-1);
  const [fundDetails, setFundDetails] = useState(null);
  const [durationValues, setDurationValues] = useState({});
  const [carouselData, setCarouselData] = useState(null);
  const [mdSection, setmdSection]= useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [combineCarousal, setcombineCarousal] = useState();
  const [latestpost, setLatestpost] = useState();
  // const [dragging, setDragging] = useState(false);
  // const [startX, setStartX] = useState(0);
  const [metaData, setmetaData] = useState();
  const [isDesktop, setIsDesktop] = useState(true); 
  // const [loadImg, setLoadImg] = useState(false);
  const [scrollHeight, setScrollHeight] = useState(0);

  const [desktopQuick, setDesktopQuick] = useState(true);

  const cntrRef = useRef(null);
  const [xPosition, setX] = useState();
  const slider = [useRef(null)];
  const [totalSlides, setTotalSlides] = useState(0);
  const [currenSlide, setCurrenSlide] = useState(0);
  const [index,setIndex] = useState(0);

  const [shortsData, setshortsData] = useState(null);
  const [newFundOffering, setnewFundOffering] = useState(null);
  const [pageID, setpageID] = useState(null);
  const [checkAppBrowser, setcheckAppBrowser] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const wrapper = document.getElementsByClassName('wrapper')[0];
      if (wrapper) {
        const scrollPosition = Math.floor(window.scrollY);
        setScrollHeight(scrollPosition);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);

  const handleTabHover = (index) => {
    setActiveTab(index);
  };
  const handleClick = (key) => {
    setCardId(key);
    if (cardId == -1 || cardId === key) setShare((prev) => !prev);
  };

  const addTodo = () => {
    setShare(false);
  };

  //new slider

  const settings = {
    infinite: fundDetails && fundDetails.length > 3,
    swipe: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    speed: 300,
    draggable: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    // let res = getTrendingFundData && getTrendingFundData();
    !trendingFundData.data && getTrendingFundData();
    !home.quicklinks && getHome();
    !homepageData.homePage && onLoad();
  }, []);

  useEffect(() => {
      setcombineCarousal(carouselData);
  }, [carouselData]);

  // End - Add adobe caurosal


  useEffect(() => {
    if (trendingFundData && trendingFundData.apiLoaded) {
      setFundDetails(trendingFundData.data && trendingFundData.data.trending);
    }
  }, [trendingFundData]);

  useEffect(() => {
    if (fundDetails) {
      const updatedValues = fundDetails.reduce((acc, item) => {
        acc[item.fundName] = "11";
        return acc;
      }, {});
      setDurationValues(updatedValues);
    }
  }, [fundDetails]);

  const handleDurationChange = (fundName, value) => {
    setDurationValues((currentValue) => ({
      ...currentValue,
      [fundName]: value,
    }));
  };

  const getImageSrc = (riskProfile) => {
    var pathName = "null";
    var riskProfile = riskProfile.split(" ").join("").toLowerCase();

    if (riskProfile.includes("moderatelyhigh")) pathName = "moderately-high";
    else if (riskProfile.includes("veryhigh")) pathName = "very-high";
    else if (
      (riskProfile.includes("to") && riskProfile.includes("moderate")) ||
      riskProfile.includes("moderate")
    )
      pathName = "moderate";
    else if (riskProfile.includes("moderatelylow")) pathName = "moderately-low";
    else if (riskProfile.includes("high")) pathName = "high";
    else if (riskProfile.includes("low") && !riskProfile.includes("to"))
      pathName = "low";

    return pathName;
  };

  const onSmallCase = async (item) => {
    let modalData = {
      closeAction: closePopup,
      modalClass: "basic-form",
      postInvestDataETF,
      postSmallCase,
      item,
      postSmallCaseID,
      location,
    };
    openPopup(MODALS.BASIC_FORM, modalData);
  };

  const onAddToCartClick = (fundName, fundCode, returnVal, invest) => {
    if(invest == "Invest Now"){
      cookie.save("isInvest", true, { path: "/" });
    }
    else{
      cookie.save("isInvest", false, { path: "/" });
    }
    cookie.save("isJanNivesh", false, { path: "/" });
    let modalData = {
      modalClass: "ecart-modal",
      fundName: fundName,
      fundCode: fundCode,
      returnValue: { duration: durationValues[fundName], value: returnVal },
      isDirect: true,
      isRegular: false,
      invest: invest,
    };
    openPopup(MODALS.ECART_MODAL, modalData);
  };

  const onLoad = () => {
    let data = formDataGenerator({
      sliderID: "home",
      youTubeShort : 'mutual-fund-shorts',
      fundOfferingID : 'new-fund-offering',
      homePageID: 'home-page',
    });
    // homepageData && !homepageData.sliderbanner &&
    getHomePageDataStatic(data);
  };

  // useEffect(() => {
  //   onLoad();
  // }, []);

  useEffect(() => {
    if (homepageData && homepageData.apiLoaded && homepageData.sliderbanner) {
      setCarouselData(homepageData.sliderbanner.data);
    }
    if(homepageData && homepageData.apiLoaded && homepageData.mutualFundShort){
      setshortsData(homepageData.mutualFundShort.data)
    }
    if(homepageData && homepageData.apiLoaded && homepageData.newFundOffering){
      setnewFundOffering(homepageData.newFundOffering);
    }
    if(homepageData && homepageData.apiLoaded && homepageData.homePage){
      setpageID(homepageData.homePage);
    }
  }, [homepageData]);

 
  // useEffect(() => {
  //   const interval = setTimeout(() => {
  //     if (!dragging) {
  //       setCurrentIndex((currentIndex + 1) % combineCarousal.length);
  //     }
  //   }, 8000);

  //   return () => clearTimeout(interval);
  // }, [dragging, currentIndex, combineCarousal]);

  // const handleDragStart = (event) => {
  //   event.preventDefault();
  //   setDragging(true);
  //   setStartX(event.type === 'touchstart' ? event.touches[0].clientX : event.clientX);
  // };

  // const handleDragMove = (event) => {
  //   if (dragging) {
  //     const currentX = event.type === 'touchmove' ? event.touches[0].clientX : event.clientX;
  //     const deltaX = currentX - startX;
  //     if (deltaX > 50) {
  //       setCurrentIndex((currentIndex - 1 + combineCarousal.length) % combineCarousal.length);
  //       setDragging(false);
  //     } else if (deltaX < -50) {
  //       setCurrentIndex((currentIndex + 1) % combineCarousal.length);
  //       setDragging(false);
  //     }
  //   }
  // };

  // const handleDragEnd = () => {
  //   setDragging(false);
  // };

  const switchToRisk = () => {
    setTabIndex(1);
    window.scrollTo({
      top: 1000,
      behavior: "smooth",
    });
  };
  const switchToGoals = () => {
    setTabIndex(0);
  };

  useEffect(() => {
    history.push("/");
  }, []);

  // useEffect(()=>{
  //   getHome();
  // },[])

  useEffect(()=>{
    if(home && home.quicklinks){
      setLatestpost(home.quicklinks);
    }
    if(home && home.meta){
      setmetaData(home.meta);
    }
    if(home && home.mdData){
      setmdSection(home.mdData);
    }
  },[home])

  const getPosition = () => {
    const xPosition = cntrRef.current?.offsetLeft;
    setX(xPosition);
  };
  const getSlides = () => {
    const slidesCount = Math.ceil(slider.current?.props.children.length - (settings.slidesToShow-settings.slidesToScroll));
    setTotalSlides(slidesCount);
  };
  useEffect(() => {
    getPosition();
    getSlides();
    window.addEventListener("resize", getPosition);
  }, []);
  
  useEffect(()=>{
   let temp = slider && slider[index] && slider[index].current && slider[index].current.props && slider[index].current.props.children.length ? Math.ceil(slider[index].current?.props.children.length - (settings.slidesToShow-settings.slidesToScroll)) : 1 ;
   setTotalSlides(temp)
  },[index])

  const settingspost = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 1000,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    afterChange: (current) => {
        if(current < slider[index].current?.props.children.length == false){
          setCurrenSlide(0);
        }
        else if(current < slider[index].current?.props.children.length - (settings.slidesToShow-settings.slidesToScroll)){
        setCurrenSlide(current);
      }
        else{
          setCurrenSlide((slider[index].current?.props.children.length - (settings.slidesToShow-settings.slidesToScroll))-1)
        }
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsDesktop(window.innerWidth > 991);
    };
    const handleWindowSizeChangequick = () => {
      setDesktopQuick(window.innerWidth > 767);
    };
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange(); // Call the function initially to set the initial state
    window.addEventListener('resize', handleWindowSizeChangequick);
    handleWindowSizeChangequick();
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
      window.removeEventListener('resize', handleWindowSizeChangequick);
    };
  }, []);
  // const storeyoutubeIDInCookie = (youtubeid, index) => {
  //   const dataindex = {
  //     youtubeid: youtubeid,
  //     index: index,
  //   };
  //   cookie.save('shortsYoutubeID', JSON.stringify(dataindex), { path: '/' });
  // };
  const settingsNewFund = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false,
  }
  const settingsDiscoverMore = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false,
  }
  const settingsbanners={
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    swipe: false,
  }

  useEffect(() => {
    if(browserName && browserName.includes('Safari')){
      setcheckAppBrowser('IOS');
    }    
  }, [browserName]);

  return (
    <div className="wrapper">
       {metaData ? (
        <Helmet>
          <title>{metaData && metaData.title ? metaData.title : ""}</title>
          <meta name="description" content={metaData && metaData.description ? metaData.description : "" }/>
          <meta name="keywords" content={metaData && metaData.keywords ? metaData.keywords : "" }/>
          <meta property="og:title" content={metaData && metaData.og_title ? metaData.og_title : "" }/>
          <meta property="og:description" content={ metaData && metaData.og_description ? metaData.og_description : "" } />
          <meta property="og:image" content={ metaData && metaData.og_image ? metaData.og_image : ""} />
          <meta property="og:url" content={ metaData && metaData.og_url ? metaData.og_url : "" } />
        </Helmet>
        ) : ("")
      }
        {/* <div className='customcontainer'>
          <div className='row'>
            <div className='col-lg-9 p-0'>
              <div className="carousel-container"
              onMouseDown={handleDragStart}
              onMouseMove={handleDragMove}
              onMouseUp={handleDragEnd}
              onMouseLeave={handleDragEnd}
              onTouchStart={handleDragStart}
              onTouchMove={handleDragMove}
              onTouchEnd={handleDragEnd}>
              {combineCarousal && combineCarousal[currentIndex] &&
                <div
                className="carousel"
                >
                  {isDesktop ?
                    <img src={combineCarousal[currentIndex].image && combineCarousal[currentIndex].image.url} className='bannerimage desktopbanner' alt='banner image carousal' loading='eager' onLoad={() => setLoadImg(true)}/> 
                  :
                    <img src={combineCarousal?.[currentIndex]?.mobileimage?.url || ''} className='bannerimage mobbanner' width={432} height={434} alt='banner image carousal' loading='eager' onLoad={() => setLoadImg(true)}/> 
                  }
                  {loadImg == true ? (
                    <>
                    <div className='buttondivs container'>
                        {combineCarousal[currentIndex].cta && combineCarousal[currentIndex].cta != null &&
                          <a className="carousel-bt1" href={combineCarousal[currentIndex].cta.uri} aria-label={combineCarousal[currentIndex].cta.title}>
                            <button>{combineCarousal[currentIndex].cta.title}</button>
                          </a>
                        }
                        {combineCarousal[currentIndex].cta2 && combineCarousal[currentIndex].cta2 != null && (
                          <a className="extra-button" href={combineCarousal[currentIndex].cta2.uri} aria-label={combineCarousal[currentIndex].cta2.title}>
                            <button>{combineCarousal[currentIndex].cta2.title}</button> 
                          </a>
                        )}
                    </div>
                      <div className="carousel-dots">
                        {combineCarousal.map((_, index) => (
                          <button
                            key={index}
                            className={`dot ${index === currentIndex ? "active" : ""}`}
                            onClick={() => setCurrentIndex(index)}
                            aria-label="buttons dot"
                          ></button>
                        ))}
                      </div>
                    </>
                  ) : "" }
                </div>
              } 
              </div> 
            </div>
            <div className='col-lg-3 quick-tabs'>
              <div className="container">
                {isDesktop && (<div className="row quicktabrow">
                  <div className='col-6'>
                      <a href="https://investor-web.hdfcfund.com/kyc-verification" className="quick-tab" rel="nofollow">
                        <img
                          src="/images/New/images/updatekyc.svg"
                          alt="Register Now icon"
                          className="quick-tab-icon"
                          loading='lazy'
                        />
                        <div className="quick-tab-title">Update KYC</div>
                      </a>
                  </div>
                  <div className='col-6'>
                      <a href="https://www.camskra.com" className="quick-tab" rel="nofollow">
                        <img
                          src="/images/New/images/checkkyc.svg"
                          alt="Check KYC icon"
                          className="quick-tab-icon"
                        />
                        <div className="quick-tab-title">Check KYC status</div>
                      </a>
                  </div>
                  <div className='col-6'>
                      <a href="https://investor-web.hdfcfund.com/new-investor/kyc-verification?_gl=1*1a8gm14*_gcl_au*MTQyMDc3MTAyNy4xNzE0MzY0NTc2" className="quick-tab" rel="nofollow">
                        <img
                          src="/images/New/images/register.svg"
                          alt="ter icon"
                          className="quick-tab-icon"
                        />
                        <div className="quick-tab-title">Register Now</div>
                      </a>
                  </div>
                  <div className='col-6'>
                      <a href="https://investor-web.hdfcfund.com/instant-login" className="quick-tab" rel="nofollow">
                        <img
                          src="/images/New/images/startsip.svg"
                          alt="Start sip icon"
                          className="quick-tab-icon"
                          loading='lazy'
                        />
                        <div className="quick-tab-title">Start SIP</div>
                      </a>
                  </div>
                  <div className='col-6'>
                      <a href="/learners-corner/sip-calculator" className="quick-tab">
                        <img
                          src="/images/New/images/calculate.svg"
                          alt="Calculate sip icon"
                          className="quick-tab-icon"
                          loading='lazy'
                        />
                        <div className="quick-tab-title">Calculate SIP</div>
                      </a>
                  </div>
                  <div className='col-6'>
                      <a href="/account-statement" className="quick-tab">
                        <img
                          src="/images/New/images/download.svg"
                          alt="Download A/C statement icon"
                          className="quick-tab-icon"
                          loading='lazy'
                        />
                        <div className="quick-tab-title">Account Statement</div>
                      </a>
                  </div>
                  <div className='col-6'>
                    <a href="/nav-and-idcw/latest-navs-and-idcw" className="quick-tab">
                      <img
                        src="/images/New/images/nav_dividend.svg"
                        alt="NAV and Dividend icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                      <div className="quick-tab-title">
                        Check NAV & Dividend (IDCW)
                      </div>
                    </a>
                  </div>
                  <div className='col-6'>
                      <a href="/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports" className="quick-tab">
                        <img
                          src="/images/New/images/TER.svg"
                          alt="ter icon"
                          className="quick-tab-icon"
                          loading='lazy'
                        />
                        <div className="quick-tab-title">View TER (Total Expense Ratio)</div>
                      </a>
                  </div>
                </div>)}
              </div>
              {isDesktop == false && (<div className='quicetabmobile'>
                <div className='maindiv'>
                  <a href="https://investor-web.hdfcfund.com/kyc-verification" className="quick-tabmob" rel="nofollow">
                    <div className='icondiv'>
                      <img
                        src="/images/New/images/updatekyc.svg"
                        alt="Register Now icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                    </div>
                    <div className="quick-tab-title">Update KYC</div>
                  </a>
                  <a href="https://www.camskra.com" className="quick-tabmob" rel="nofollow">
                    <div className='icondiv'>
                      <img
                        src="/images/New/images/checkkyc.svg"
                        alt="Check KYC icon"
                        className="quick-tab-icon"
                      />
                    </div>
                    <div className="quick-tab-title">Check KYC status</div>
                  </a>
                  <a href="https://investor-web.hdfcfund.com/new-investor/kyc-verification?_gl=1*1a8gm14*_gcl_au*MTQyMDc3MTAyNy4xNzE0MzY0NTc2" className="quick-tabmob" rel="nofollow">
                    <div className='icondiv'>
                      <img
                        src="/images/New/images/register.svg"
                        alt="Register Now icon"
                        className="quick-tab-icon"
                      />
                    </div>
                    <div className="quick-tab-title">Register Now</div>
                  </a>
                  <a href="https://investor-web.hdfcfund.com/instant-login" className="quick-tabmob" rel="nofollow">
                    <div className='icondiv'>
                      <img
                        src="/images/New/images/startsip.svg"
                        alt="Start sip icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                    </div>
                    <div className="quick-tab-title">Start SIP</div>
                  </a>
                  <a href="/learners-corner/sip-calculator" className="quick-tabmob">
                    <div className='icondiv'>
                      <img
                        src="/images/New/images/calculate.svg"
                        alt="Calculate sip icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                    </div>
                    <div className="quick-tab-title">Calculate SIP</div>
                  </a>
                  <a href="/account-statement" className="quick-tabmob">
                    <div className='icondiv'>
                      <img
                        src="/images/New/images/download.svg"
                        alt="Download A/C statement icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                    </div>
                    <div className="quick-tab-title">Account Statement</div>
                  </a>
                  <a href="/nav-and-idcw/latest-navs-and-idcw" className="quick-tabmob">
                    <div className='icondiv'>
                      <img
                        src="/images/New/images/nav_dividend.svg"
                        alt="NAV and Dividend icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                    </div>
                    <div className="quick-tab-title">
                      Check NAV & Dividend (IDCW)
                    </div>
                  </a>
                  <a href="/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports" className="quick-tabmob">
                    <div className='icondiv'>
                      <img
                        src="/images/New/images/TER.svg"
                        alt="ter icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                    </div>
                    <div className="quick-tab-title">View TER (Total Expense Ratio)</div>
                  </a>
                </div>
              </div>)}
            </div>
          </div>
        </div> */}

        <div className='container firstDiv'>
          <div className='row'>
            <div className='col-md-7 mb-5 mb-md-0'>
              {pageID && pageID.body &&
                <div
                  dangerouslySetInnerHTML={{
                    __html: pageID.body,
                  }}
                />
              }
                <div className='btndiv'>
                  <a href={pageID  && pageID.links && pageID.links[0] && pageID.links[0].uri} className='funds'>{pageID  && pageID.links && pageID.links[0] && pageID.links[0].title}</a>
                  <a href={pageID  && pageID.links && pageID.links[1] && pageID.links[1].uri} className='startsip'>{pageID && pageID.links && pageID.links[1] && pageID.links[1].title}</a>
                </div>
                <div className='d-flex justify-content-center my-5 lastRating'>
                  <div className='rating'>
                    <p className='heading'>Avg. App Rating</p>
                    <p className='detail'>{pageID && pageID.AvgAppRating}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.24325 7.33992L1.86325 8.26492L1.75025 8.28792C1.57919 8.33333 1.42325 8.42333 1.29835 8.54872C1.17344 8.67412 1.08406 8.83041 1.03932 9.00165C0.994575 9.17289 0.996081 9.35293 1.04368 9.5234C1.09128 9.69386 1.18327 9.84864 1.31025 9.97192L5.93225 14.4709L4.84225 20.8259L4.82925 20.9359C4.81878 21.1128 4.85552 21.2894 4.9357 21.4474C5.01589 21.6055 5.13664 21.7394 5.28559 21.8354C5.43454 21.9315 5.60634 21.9862 5.7834 21.994C5.96046 22.0018 6.13642 21.9625 6.29325 21.8799L11.9993 18.8799L17.6923 21.8799L17.7923 21.9259C17.9573 21.9909 18.1367 22.0109 18.312 21.9837C18.4873 21.9565 18.6522 21.8832 18.7898 21.7712C18.9275 21.6592 19.0328 21.5127 19.0951 21.3466C19.1574 21.1804 19.1743 21.0008 19.1443 20.8259L18.0533 14.4709L22.6773 9.97092L22.7553 9.88592C22.8667 9.74869 22.9397 9.58438 22.967 9.40972C22.9942 9.23506 22.9747 9.0563 22.9103 8.89165C22.846 8.72701 22.7392 8.58235 22.6007 8.47244C22.4623 8.36252 22.2972 8.29126 22.1223 8.26592L15.7423 7.33992L12.8903 1.55992C12.8077 1.39246 12.68 1.25144 12.5214 1.15283C12.3629 1.05422 12.1799 1.00195 11.9933 1.00195C11.8066 1.00195 11.6236 1.05422 11.4651 1.15283C11.3065 1.25144 11.1788 1.39246 11.0963 1.55992L8.24325 7.33992Z" fill="url(#paint0_linear_4022_6403)"/>
                      <defs>
                      <linearGradient id="paint0_linear_4022_6403" x1="6" y1="8" x2="20.5" y2="22" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F9DC00"/>
                      <stop offset="1" stop-color="#FFAE00"/>
                      </linearGradient>
                      </defs>
                    </svg>
                    </p>
                  </div>
                  <div className='rating'>
                  <p className='heading aumtooltip'>AUM
                  {/* <div className="aumtooltip"> */}
                    <img src="/images/New/product-solution/info.svg" alt='info icon' width={14} height={14} className='ms-1 info-icon' />
                      <div className="aumtooltiptext">
                        <p>Assets Under Management<br/> <span>(AUM)</span></p>
                        <a href='/statutory-disclosure/aum' target='_blank'>View Details <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.00065 3.00065H3.00065C2.55862 3.00065 2.1347 3.17625 1.82214 3.48881C1.50958 3.80137 1.33398 4.22529 1.33398 4.66732V13.0006C1.33398 13.4427 1.50958 13.8666 1.82214 14.1792C2.1347 14.4917 2.55862 14.6673 3.00065 14.6673H11.334C11.776 14.6673 12.1999 14.4917 12.5125 14.1792C12.8251 13.8666 13.0006 13.4427 13.0006 13.0006V8.00065M7.16732 8.83398L14.6673 1.33398M14.6673 1.33398H10.5007M14.6673 1.33398V5.50065" stroke="#032AF9" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg></a>
                      </div>
                    {/* </div> */}
                  </p>
                    <p className='detail'>₹ {pageID && pageID.Aum ? pageID.Aum : ''}</p>
                  </div>
                   {/* <div className='rating'> */}
                   <h3 className='heading1'>Distributors <br /> <p className='detail1'>{pageID && pageID.FundsOffered ? pageID.FundsOffered : ''} </p></h3>
                  {/* <p className='detail1'>{pageID && pageID.FundsOffered ? pageID.FundsOffered : ''}</p> */}
                  {/* </div> */}
                </div>
            </div>
            <div className='col-md-5 mb-5 mb-md-0 sliderback'>
              <div className='slidermain'>
              <img src="/images/New/Homepagestatic/GrideFinal.webp" fetchpriority="high" alt="Mobile image" className='mobilescreen'/>
              <div className='mainSlider'>
                <div className='sliderdiv'>
                  <Slider {...settingsbanners} >
                    {heroBanner && heroBanner.map((item, index)=>{
                      return(
                        <div>
                          <div className='slider-imgs'>
                            <img src={item.image ? item.image :''} alt={item.alt ? item.alt :''} className='mx-auto'/>
                          </div>
                          {/* <div className='funddiv'>                         */}
                            {item.slug && <a href={item.slug} className='knowmore'>Know More</a>}
                          {/* </div> */}
                        </div>
                      )
                    })}
                  </Slider>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div className='quick-tabs'>
          <div className="container">
            <h2 className='quicktitle'>Quick Links</h2>
            {isDesktop && (
              <div className="row quicktabrow">
                <div className='col-3'>
                    <a href="/important-announcement" className="quick-tab">
                      <img
                        src="/images/New/images/announcement.svg"
                        alt="Important Announcement Icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                      <div className="quick-tab-title">Regulatory Announcements</div>
                    </a>
                </div>
                <div className='col-3'>
                    <a href="https://investor-web.hdfcfund.com/kyc-verification" className="quick-tab" rel="nofollow">
                      <img
                        src="/images/New/images/updatekyc.svg"
                        alt="Update KYC icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                      <div className="quick-tab-title">Update KYC</div>
                    </a>
                </div>
                <div className='col-3'>
                    <a href="https://investor-web.hdfcfund.com/new-investor/kyc-verification?_gl=1*1a8gm14*_gcl_au*MTQyMDc3MTAyNy4xNzE0MzY0NTc2" className="quick-tab" rel="nofollow">
                      <img
                        src="/images/New/images/register.svg"
                        alt="Sign Up icon"
                        className="quick-tab-icon"
                      />
                      <div className="quick-tab-title">Sign Up</div>
                    </a>
                </div>
                <div className='col-3'>
                    <a href="/learners-corner/sip-calculator" className="quick-tab">
                      <img
                        src="/images/New/images/calculate.svg"
                        alt="Calculate sip icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                      <div className="quick-tab-title">Calculate SIP</div>
                    </a>
                </div>
                <div className='col-3'>
                    <a href="https://www.camskra.com" className="quick-tab" rel="nofollow">
                      <img
                        src="/images/New/images/checkkyc.svg"
                        alt="Check KYC status icon"
                        className="quick-tab-icon"
                      />
                      <div className="quick-tab-title">Check KYC status</div>
                    </a>
                </div>
                <div className='col-3'>
                    <a href="/nav-and-idcw/latest-navs-and-idcw" className="quick-tab">
                      <img
                        src="/images/New/images/nav_dividend.svg"
                        alt="NAV and Dividend icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                      <div className="quick-tab-title">
                        Check NAV & IDCW
                      </div>
                    </a>
                </div>
                <div className='col-3'>
                    <a href="/account-statement" className="quick-tab">
                      <img
                        src="/images/New/images/download.svg"
                        alt="Download A/C statement icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                      <div className="quick-tab-title">Download A/C statements</div>
                    </a>
                </div>
              
                <div className='col-3'>
                    <a href="/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports" className="quick-tab">
                      <img
                        src="/images/New/images/TER.svg"
                        alt="ter icon"
                        className="quick-tab-icon"
                        loading='lazy'
                      />
                      <div className="quick-tab-title">View Total Expense Ratio (TER)</div>
                    </a>
                </div>
              </div>
            )}
          </div>
          {isDesktop == false && (<div className='quicetabmobile'>
            <div className='maindiv'>
              <a href="/important-announcement">
                <div className="quick-tabmob">
                  {/* <div className='icondiv'> */}
                    <img
                      src="/images/New/images/announcement.svg"
                      alt="Regulatory Announcements icon"
                      className="quick-tab-icon"
                      loading='lazy'
                    />
                  {/* </div> */}
                  <div className="quick-tab-title">Regulatory Announcements</div>
                </div>
              </a>
              <a href="https://investor-web.hdfcfund.com/kyc-verification" rel="nofollow">
                <div className="quick-tabmob">
                  {/* <div className='icondiv'> */}
                    <img
                      src="/images/New/images/updatekyc.svg"
                      alt="Update KYC icon"
                      className="quick-tab-icon"
                      loading='lazy'
                    />
                  {/* </div> */}
                  <div className="quick-tab-title">Update KYC</div>
                </div>
              </a>
              <a href="https://investor-web.hdfcfund.com/new-investor/kyc-verification?_gl=1*1a8gm14*_gcl_au*MTQyMDc3MTAyNy4xNzE0MzY0NTc2" rel="nofollow">
                <div className="quick-tabmob">
                  {/* <div className='icondiv'> */}
                    <img
                      src="/images/New/images/register.svg"
                      alt="Sign Up icon"
                      className="quick-tab-icon"
                    />
                  {/* </div> */}
                  <div className="quick-tab-title">Sign Up</div>
                </div>
              </a>
              <a href="/learners-corner/sip-calculator">
                <div className="quick-tabmob">
                  {/* <div className='icondiv'> */}
                    <img
                      src="/images/New/images/calculate.svg"
                      alt="Calculate sip icon"
                      className="quick-tab-icon"
                      loading='lazy'
                    />
                  {/* </div> */}
                  <div className="quick-tab-title">Calculate SIP</div>
                </div>
              </a>
              <a href="https://www.camskra.com" rel="nofollow">
                <div className="quick-tabmob">
                  {/* <div className='icondiv'> */}
                    <img
                      src="/images/New/images/checkkyc.svg"
                      alt="Check KYC icon"
                      className="quick-tab-icon"
                    />
                  {/* </div> */}
                  <div className="quick-tab-title">Check KYC status</div>
                </div>
              </a>
              <a href="/nav-and-idcw/latest-navs-and-idcw">
                <div className="quick-tabmob">
                  {/* <div className='icondiv'> */}
                    <img
                      src="/images/New/images/nav_dividend.svg"
                      alt="NAV and Dividend icon"
                      className="quick-tab-icon"
                      loading='lazy'
                    />
                  {/* </div> */}
                  <div className="quick-tab-title">
                    Check NAV & IDCW
                  </div>
                </div>
              </a>
              <a href="/account-statement">
                <div className="quick-tabmob">
                  {/* <div className='icondiv'> */}
                    <img
                      src="/images/New/images/download.svg"
                      alt="Download A/C statement icon"
                      className="quick-tab-icon"
                      loading='lazy'
                    />
                  {/* </div> */}
                  <div className="quick-tab-title">Download A/C statements</div>
                </div>
              </a>
            
              <a href="/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports">
                <div className="quick-tabmob">
                  {/* <div className='icondiv'> */}
                    <img
                      src="/images/New/images/TER.svg"
                      alt="ter icon"
                      className="quick-tab-icon"
                      loading='lazy'
                    />
                  {/* </div> */}
                  <div className="quick-tab-title">View Total Expense Ratio (TER)</div>
                </div>
              </a>
            </div>
          </div>)}
        </div>
        {newFundOffering && newFundOffering.data && newFundOffering.data.length > 0 && scrollHeight >= 240 &&
        <div className='newFund container'>
          <div className='row justify-content-center'>
            <div className='col-md-10'>
              <h2>New Fund Offering</h2>
              <Slider {...settingsNewFund}>
                {newFundOffering && newFundOffering.data && newFundOffering.data.length > 0 && newFundOffering.data.map((item, index)=>{
                  return(
                    <div className='maindiv'>
                      {isDesktop ?
                      <img src={item.image && item.image.url ? item.image.url : ''} alt={item.image && item.image.alt ? item.image.alt : ''} className='img-fluid newfundimg'/>
                      :
                      <img src={item.mobileimage && item.mobileimage.url ? item.mobileimage.url : ''} alt={item.mobileimage && item.mobileimage.alt ? item.mobileimage.alt : ''} className='img-fluid newfundimg'/>
                      }
                      <div className='buttondiv'>
                        {item.cta && item.cta.uri && <a href={item.cta.uri} className='button1'>{item.cta && item.cta.title ? item.cta.title :''}</a>}
                        {item.cta2 && item.cta2.uri && <a href={item.cta2.uri} className='button2'>{item.cta2 && item.cta2.title ? item.cta2.title :''}</a>}
                      </div>
                    </div>
                  )
                })}
              </Slider>
            </div>
          </div>
        </div>}

        {scrollHeight >= 240 && (
          <div className='bluecls py-2'>
          <div className="trending-fund-container container-new">
          <div className="trending-schemes">Our Funds</div>
          {fundDetails && fundDetails.length >= 1 ? (
            <Slider {...settings}>
              {fundDetails &&
                fundDetails.map((item, index) => (
                  <div className="trending-fund-cards" key={index}>
                    <div className="fund-card-content">
                      <div className="fund-card-head">
                        <div className="fund-title">
                          {item.item && (
                            <a
                              href={`/product-solutions/overview/${item.item.suggestedUrl}/direct`}
                              aria-label={`Tittle : ${item.fundName}`}
                            >
                              {item.fundName && item.fundName}
                            </a>
                          )}
                          <div className='d-flex'>
                            <img src='/images/New/product-solution/Iconsaddtocart.svg'
                              width={25}
                              height={25}
                              className='cursorp cart-icon'
                              alt='add to cart icon'
                              onClick={() =>
                                onAddToCartClick(
                                  item.fundName,
                                  item.fundCode,
                                  item.annualisedReturns &&
                                  item.annualisedReturns[
                                  durationValues[item.fundName]
                                  ],
                                  '',
                                )
                              } />
                            <span
                              className="share ms-2"
                              onClick={() => handleClick(index)}
                            >
                              <img
                                src="/images/New/Homepagestatic/share.svg"
                                className="share-icon"
                                alt="share icon"
                                width={20}
                                height={20}
                              />
                              {share && cardId === index && (
                                <SocialShare
                                  fundName={getRouting(
                                    item.item.routeConstant,
                                    item.item.suggestedUrl
                                  )}
                                />
                              )}
                            </span>
                          </div>
                        </div>
                        {/* <p >24K+ Investors have invested in this fund.</p> */}
                      </div>
                      <div className="fund-card-body">
                        <p className="fundtitle">Return</p>
                        <ul className="fund-duration">
                          {[
                            { title: "1 year", value: 1 },
                            { title: "3 years", value: 3 },
                            { title: "5 years", value: 5 },
                            { title: "10 years", value: 10 },
                            { title: "Since Inception", value: 11 },
                          ].map((duration) => {
                            return (
                              <li
                                className={
                                  duration.value ==
                                  durationValues[item.fundName]
                                    ? "selectedDuration"
                                    : ""
                                }
                                onClick={() =>
                                  handleDurationChange(
                                    item.fundName,
                                    duration.value
                                  )
                                }
                              >
                                {duration.title}
                              </li>
                            );
                          })}
                        </ul>
                        <div className="fund-returns">
                          <div className="fundReturninner">
                            <p className="title">CAGR</p>
                            <p
                              className={
                                item.annualisedReturns &&
                                item.annualisedReturns[
                                  durationValues[item.fundName]
                                ] > 0
                                  ? "greenfund"
                                  : "redfund"
                              }
                            >
                              {item.annualisedReturns &&
                              item.annualisedReturns[
                                durationValues[item.fundName]
                              ] ? (
                                round(
                                  item.annualisedReturns[
                                    durationValues[item.fundName]
                                  ],
                                  2
                                ) + "%"
                              ) : (
                                <div className="percent d-flex pe-2">
                                  NA{" "}
                                  <span className="title ms-1">
                                    (The inception<br></br> date is{" "}
                                    {item.inceptionDate})
                                  </span>
                                </div>
                              )}
                              {item.annualisedReturns &&
                              item.annualisedReturns[
                                durationValues[item.fundName]
                              ] ? (
                                <svg
                                  width="24"
                                  height="24"
                                  className="cagrimg"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16 14L12 18M12 18L8 14M12 18V6"
                                    stroke={
                                      item.annualisedReturns &&
                                      item.annualisedReturns[
                                        durationValues[item.fundName]
                                      ] > 0
                                        ? "#008000"
                                        : "#EB1C24"
                                    }
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              ) : (
                                ""
                              )}
                            </p>
                          </div>
                          <div className="fundReturninner">
                            <p className="title text-end">Benchmark Returns</p>
                            <p className="percent text-end">
                              {item.benchmarkReturns &&
                              item.benchmarkReturns[
                                durationValues[item.fundName]
                              ]
                                ? round(
                                    item.benchmarkReturns[
                                      durationValues[item.fundName]
                                    ],
                                    2
                                  ) + "%"
                                : "NA"}
                            </p>
                          </div>
                        </div>
                        <div className="fund-detail">
                          {/* <div className="breakline"></div> */}
                          <div className="about-fund">
                            <div className="fund-nav title">
                                {`NAV (as of ${
                                  item.navDateTimestamp && item.navDateTimestamp
                                })`}
                              <p className="value">
                                {item.navAmount && round(item.navAmount, 2)}
                              </p>
                            </div>
                            <div className="fund-risk-rating">
                              <p className="risktitle">
                                Riskometer
                                {/* <div className="riskometertooltip"> */}
                                  <img
                                    src="/images/New/product-solution/info.svg"
                                    alt="info icon"
                                    width={12}
                                    height={12}
                                    className='infoicon'
                                  />
                                    {item.riskReturnProfile && (
                                      <img
                                        src={
                                          item.riskReturnProfile &&
                                          `/images/HomePage/Riskometer/${getImageSrc(
                                            item.riskReturnProfile
                                          )}.webp`
                                        }
                                        className="riskotooltiptext risktip"
                                        width={250}
                                        height={180}
                                        alt="riskometer icon"
                                        loading="lazy"
                                      />
                                    )}
                                {/* </div> */}
                              </p>
                              <div className="riskvaluediv">
                                {item.riskReturnProfile && (
                                  <img
                                    src={
                                      item.riskReturnProfile &&
                                      `/images/HomePage/${getImageSrc(
                                        item.riskReturnProfile
                                      )}.svg`
                                    }
                                    alt="risk icon"
                                  />
                                )}
                                <p className="risk-value">
                                  {item.riskReturnProfile &&
                                    item.riskReturnProfile}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="suitable">
                              {item.sutiableFor && item.sutiableFor.title
                                ? item.sutiableFor.title
                                : ""}
                              &nbsp;:&nbsp;
                              <span>
                                {item.sutiableFor &&
                                  item.sutiableFor.values &&
                                  item.sutiableFor.values[0]}
                              </span>
                          </div>
                          <div className="benchmark-title">
                            <p className="title">
                              {item.suggestedInvestment.title
                                ? item.suggestedInvestment.title
                                : "NA"}
                              &nbsp;:&nbsp;
                            </p>
                            <p className="detail">
                              {item.suggestedInvestment.values
                                ? item.suggestedInvestment.values
                                : "NA"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="fund-card-cta">
                        {item.item && item.item.nodeID == 153 ? (
                          <>
                            <a
                              href={`/product-solutions/overview/${item.item.suggestedUrl}/direct`}
                              className="knowmore"
                            >
                              Know More
                            </a>
                            <a
                              className="invest-now"
                              href="https://mycams.camsonline.com/camsapp/myCAMSInvestment.aspx?amc=bY6feGFFJ8HzqBqLSb-jTlybKcI4xfSf7af84PWT3JQ="
                              target="_blank"
                              rel="noreferrer"
                            >
                              Invest Now
                            </a>
                          </>
                        ) : item.item.camsURL ? (
                          <>
                            <a
                              href={`/product-solutions/overview/${item.item.suggestedUrl}/direct`}
                              className="knowmore"
                            >
                              Know More
                            </a>
                            <a
                              className="invest-now"
                              href={item.item.camsURL}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Invest Now
                            </a>
                          </>
                        ) : item.item.categories &&
                          item.item.categories === "ETF" ? (
                          !item.item.hideInvest && (
                            <a
                              className="invest-now-btn"
                              //   style={{ borderRadius: "none" }}
                              onClick={() => onSmallCase(item.item)}
                            >
                              Invest Now
                            </a>
                          )
                        ) : (
                          !item.item.hideInvest && (
                            <>
                              <a
                                href={`/product-solutions/overview/${item.item.suggestedUrl}/direct`}
                                className="knowmore"
                              >
                                Know More
                              </a>
                              <div
                                tabIndex="0"
                                className="invest-now"
                                onClick={() =>
                                  onAddToCartClick(
                                    item.fundName,
                                    item.fundCode,
                                    item.annualisedReturns &&
                                    item.annualisedReturns[
                                    durationValues[item.fundName]
                                    ],
                                    "",
                                  )
                                }
                              >
                                Invest Now
                              </div>
                            </>
                          )
                        )}
                      </div>
                      {/* <div className='fund-card-cta'>
                                      <a  href='/investment-basket?trendingScheme=true'className='invest-now'>Invest Now</a>
                                  </div> */}
                    </div>
                  </div>
                ))}
            </Slider>
          ) : (
            <NoContent />
          )}
          <div className="view-more viewmorebtn">
              <a href="/product-solutions">View All</a>
          </div>
          </div>
          </div>
        )}

        <section className='invest-smart-container'>
          {/* <div className="invest-smart-container"> */}
            <div className="description">
              <h1>Invest Smart. Plan Now.</h1>
              <p>
                Plan your goals, understand your investment personality, and get
                a curated list of funds that match your needs.
              </p>
            </div>
            <Tabs
              selectedIndex={tabIndex}
              onSelect={(index) => {
                history.push("/");
                setTabIndex(index);
              }}
            >
              <TabList>
                <Tab>
                  <img
                    src="/images/homeIcons/goal.svg"
                    alt="goals"
                    width={30}
                    height={30}
                  />{" "}
                  Plan Your Goals
                </Tab>
                <Tab>
                  <img
                    src="/images/homeIcons/risk-profile.svg"
                    alt="riskprofile"
                    width={30}
                    height={30}
                    loading="lazy"
                  />{" "}
                  <span>
                    Know Your <span>Investment Personality</span>
                  </span>
                </Tab>
              </TabList>

              <TabPanel>
                <Goals switchToRisk={switchToRisk} location={location} scrollHeight={scrollHeight}/>
              </TabPanel>
              <TabPanel>
                <RiskProfiler
                  switchToGoals={switchToGoals}
                  location={location}
                />
              </TabPanel>
            </Tabs>
          {/* </div> */}
        </section>

        {scrollHeight >= 240 && (<section className='shorts'>
          {/* <div className='container'> */}
            <div className="container shorts-container">
              {/* <div className='titlediv'> */}
                <h2 className='titlediv'>Latest Shorts</h2>
              {/* </div> */}
              <div className='row'>
                <a href={shortsData && shortsData[0] && shortsData[0].linkUrl && `/mutual-fund-shorts/${shortsData[0].linkUrl}`} className='listpage'>
                  View all
                  <img src='images/New/Homepagestatic/md/arrow-blue.svg' className='ms-1' width="15" height="15" alt='right arrow'/>
                </a>
                {shortsData && 
                shortsData.length > 0 && 
                shortsData.map((video, index) => {
                  return(
                  <a key={index} href={`/mutual-fund-shorts/${video.linkUrl ? video.linkUrl : ''}`} className="slide">
                    <div className='posterimg' 
                    // onClick={() => storeyoutubeIDInCookie(video.youtubeVideoId, index)}
                    >
                      <img src={video.image && video.image.url ? video.image.url : ''} width={225} height={400} className="img-fluid" alt={video.image && video.image.alt ? video.image.alt : ''} />
                      <p className='videotitle'>{video.title ? video.title : ''}</p>
                    </div>
                  </a>
                )})}
              </div>
            </div>
          {/* </div> */}
        </section>)}
        
        {carouselData && carouselData.length > 0 && scrollHeight >= 240 &&
        <div className='discoverMore container'>
          <div className='row justify-content-center'>
            <div className='col-md-10'>
              <h2>Discover More</h2>
              <Slider {...settingsDiscoverMore}>
                {carouselData && carouselData.length > 0 && carouselData.map((item, index)=>{
                  return(
                    <div className='maindiv'>
                      <img src={item.image && item.image.url ? item.image.url :''} alt={item.image && item.image.alt ? item.image.alt :''} className='img-fluid discoverimg' loading="lazy"/>
                      {(item.cta && item.cta.uri) || (item.cta2 && item.cta2.uri) ?
                      <>
                        {/* <div className='buttondiv'> */}
                        {/* <p>{item.title ? item.title : ''}</p> */}
                        <div className='d-flex justify-content-center align-items-center buttondiv'>
                          {item.cta && item.cta.uri && item.cta.uri != null && <a href={item.cta.uri} className='button1'>{item.cta && item.cta.title ? item.cta.title : ''}</a>}
                          {item.cta2 && item.cta2.uri && item.cta2.uri != null && <a href={item.cta2.uri} className='button2'>{item.cta2 && item.cta2.title ? item.cta2.title : ''}</a>}
                        </div>
                        {/* </div> */}
                      </>
                      :''} 
                    </div>
                  )
                })}
              </Slider>
            </div>
          </div>
        </div>
        }

        {scrollHeight >= 240 && (
        <section className='latestpostdiv'>
          {/* <div className='container'> */}
          <div className="container latest-posts">
              <h2>Latest Posts</h2>
              {latestpost && latestpost.length >= 1 ? (
                <Slider {...settingspost} ref={slider[0]}>
                  {latestpost.map((item, index) => (
                    <a href={item.link_url} className="panel-goals" key={item.title}>
                      <div>
                        <div className="image position-relative">
                        {item.postCategory && <div className="post">{item.postCategory}</div>}
                          <img src={item.image && item.image.url} alt={item.image && item.image.alt} loading='lazy'/>
                          {/* {item.time ? <div className="timeread">{item.time ? item.time : ''}</div> : ''} */}
                        </div>
                        <div className="rectanglee">
                          {
                            // <h3>
                              <div className={`panel-box-heading ${item.title ? 'expanded' : ''}`}>
                                {item && item.title}
                              </div>
                            // </h3>
                          }
                          <a href={item.link_url} className="new" aria-label={`Read more about Latest Post ${index}`}>
                            {item && item.description}
                          </a>
                        </div>
                      </div>
                    </a>
                  ))}
                </Slider>
              ) : "" 
              }
            </div>
          {/* </div> */}
        </section>)}

        {scrollHeight >= 240 && (<section className="message-from-md">
          <div className="container mdsection">
            <h2>Insights From our MD & CEO</h2>
            <div className='d-flex justify-content-center align-items-center mb-3 mdImage'>
              <img src={mdSection && mdSection.mdImage && mdSection.mdImage.url ? mdSection.mdImage.url : "" }
              alt={mdSection && mdSection.mdImage && mdSection.mdImage.alt ? mdSection.mdImage.alt : ""} className='md-img' width={90} height={90} />
              <div className='md-title'>
                <h3 className='mb-2 mt-0'>Navneet Munot</h3>
                <p>{mdSection && mdSection.designation ? mdSection.designation :''}</p>
              </div>
            </div>
            {desktopQuick &&
            // <div className='d-flex justify-content-end'>
              <a href="/knowledge-stack/md-ceo-desk/videos" className='d-flex align-items-center mb-2 justify-content-end'>
                <span className='viewbtn me-1'>View all</span>
                <img src="/images/New/Homepagestatic/md/arrow-blue.svg" alt="left arrow icon" />
              </a>
            // </div> 
            }
            <div className="row">
                {mdSection && 
                mdSection.datalinks && 
                mdSection.datalinks.length > 0 &&
                mdSection.datalinks.map((item , index) => {
                  const posterImage = getYoutubePosterImage(item.youtubeId);
                  return (
                  <div className="col-md-3 mb-3">
                  <a href={ item.linkUrl ? item.linkUrl : item.suggestedUrl } >
                    <div className='md-card'>
                      <div className='position-relative'>
                          {item && item.thumbnail_image ? (
                              <img src={ item && 
                                item.thumbnail_image &&
                                item.thumbnail_image.url ?
                                item.thumbnail_image.url : ""
                            } 
                                alt={ item && 
                                    item.thumbnail_image &&
                                    item.thumbnail_image.alt ?
                                    item.thumbnail_image.alt : ""
                                }  
                                  className='articleimg' 
                                />
                              ) : (
                              <img src={posterImage} 
                              alt="youtube videos"
                              className='articleimg' 
                              />
                          )}

                          {desktopQuick && item.label && (
                            <div className='posts'>
                            {item.label}
                            </div>
                            )
                          }
                      </div>
                      <div className='mdbody'>
                        {desktopQuick == false &&
                          <div className='d-flex justify-content-between mb-1'>
                          {item.label ? <h3 className='mb-2'>{item.label}</h3> : ''}
                          <img src="/images/New/Homepagestatic/md/arrow-blue.svg" alt="left arrow icon" />
                          </div>
                        }
                        <p>{item.title ? item.title : "" }</p>
                        {/* {desktopQuick &&
                        <div className='readdiv'>
                          <div className='d-flex align-items-center justify-content-center'>
                            <span>{item.youtubeId && item.youtubeId.length > 0 ? "Watch Now" : "Read More"}</span>
                            <img src="/images/New/Homepagestatic/md/arrow-blue.svg" alt="left arrow icon" />
                          </div>
                        </div>
                        } */}
                      </div>
                    </div>
                  </a>
                </div>
                )
                }) 
              }
            </div>

            {desktopQuick == false &&
           // <div className='d-flex justify-content-center'>
            <a href="/knowledge-stack/md-ceo-desk/videos" className='d-flex align-items-center justify-content-center'>
            <span className='viewbtn me-1'>View all</span>
            <img src="/images/New/Homepagestatic/md/arrow-blue.svg" alt="left arrow icon" />
            </a>
           // </div>
            }
          </div>
        </section>)}

        {scrollHeight >= 240 && (<section className="qinvest">
          <div className="hdfc-container">
            <h2 className="center heading">Manage Investments Online</h2>
            <p className='subheading'>Three ways to invest with us</p>
            <div className="qbox">
              <div className="hover-tabs">
                {tabs.map((tab, index) => (
                  <div
                    key={index}
                    className={`accordion-item ${
                      index === activeTab ? "active" : ""
                    }`}
                    onMouseEnter={() => handleTabHover(index)}
                  >
                    <h2>{tab.title}</h2>
                    {index !== activeTab ? (
                      <div className="arrowbutton"></div>
                    ) : (
                      ""
                    )}
                    {index === activeTab ? (
                      <>
                        <div className="accordion-content">
                          {tab.description ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: tab.description,
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {/* <p className="button-name"> */}
                          {tab.title == "App" ? 
                            <a href={checkAppBrowser == 'IOS' ? 
                              'https://apps.apple.com/in/app/hdfc-mutual-fund/id1380088205':
                              'https://play.google.com/store/apps/details?id=com.hdfcfund.investor'} 
                              target="_blank" rel="nofollow" className="button-name"
                              aria-label={checkAppBrowser === 'IOS' 
                              ? 'Download HDFC Mutual Fund app from Apple App Store' 
                              : 'Download HDFC Mutual Fund app from Google Play Store'}
                            >
                              {tab.buttonName}
                            </a>
                          : 
                            <a href={tab.quickLink} rel="nofollow" className="button-name">{tab.buttonName}</a>
                          }
                          {/* </p> */}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div className="image-container inner">
                      <img
                        src={tab.image2}
                        alt="picture01"
                        className="investfig"
                        loading="lazy"
                      />
                    </div>
                  </div>
                ))}
                {/* <div className="tab-content"> */}
                  <div className="image-container">
                    <div className="rectangle"></div>
                    <img
                      src={
                        activeTab !== null &&
                        tabs[activeTab] &&
                        tabs[activeTab].image
                      }
                      alt="picture01"
                      className="investfig"
                      loading="lazy"
                    />
                  </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </section>)}
        {scrollHeight >= 240 && (<div className="container prilogodiv">
          <div className="row justify-content-center">
            <div className="pricol mb-4 prilogo">
              {/* <div className="mb-4 prilogo"> */}
                <svg width="300" height="120" viewBox="0 0 199 83" fill="none" xmlns="http://www.w3.org/2000/svg" className="img-fluid priload12" loading='lazy'>
                <rect x="27" y="41.7117" width="10" height="10" rx="1" fill="#05AFEA"/>
                <rect x="27" y="54.7117" width="10" height="10" rx="1" fill="#008ECF"/>
                <rect x="27" y="67.7117" width="10" height="10" rx="1" fill="#064EAA"/>
                <rect x="14" y="67.7117" width="10" height="10" rx="1" fill="#018CCF"/>
                <rect x="14" y="54.7117" width="10" height="10" rx="1" fill="#01AFED"/>
                <rect x="1" y="67.7117" width="10" height="10" rx="1" fill="#08ADE9"/>
                <path d="M47.0601 76.7117V43.2571H58.9848C61.5875 43.2571 63.7438 43.7308 65.4535 44.6783C67.1633 45.6257 68.4429 46.9217 69.2923 48.5661C70.1418 50.1996 70.5665 52.04 70.5665 54.0874C70.5665 56.1456 70.1363 57.9969 69.276 59.6414C68.4266 61.2749 67.1415 62.5708 65.4209 63.5291C63.7111 64.4766 61.5603 64.9503 58.9685 64.9503H50.7682V60.6705H58.5111C60.1555 60.6705 61.4895 60.3873 62.5132 59.821C63.5369 59.2439 64.2883 58.4598 64.7675 57.4688C65.2466 56.4778 65.4862 55.3506 65.4862 54.0874C65.4862 52.8241 65.2466 51.7024 64.7675 50.7223C64.2883 49.7422 63.5314 48.9745 62.4969 48.4191C61.4732 47.8637 60.1228 47.586 58.4457 47.586H52.1077V76.7117H47.0601ZM77.8639 76.7117V43.2571H89.7886C92.3805 43.2571 94.5313 43.7036 96.241 44.5966C97.9617 45.4896 99.2467 46.7256 100.096 48.3047C100.946 49.8729 101.37 51.6861 101.37 53.7443C101.37 55.7917 100.94 57.594 100.08 59.1513C99.2304 60.6977 97.9453 61.9011 96.2247 62.7614C94.5149 63.6217 92.3641 64.0519 89.7723 64.0519H80.7389V59.7067H89.3149C90.9484 59.7067 92.277 59.4726 93.3007 59.0043C94.3353 58.536 95.0921 57.8554 95.5713 56.9624C96.0505 56.0694 96.29 54.9967 96.29 53.7443C96.29 52.4811 96.045 51.3866 95.555 50.461C95.0758 49.5353 94.3189 48.8274 93.2844 48.3374C92.2607 47.8364 90.9157 47.586 89.2496 47.586H82.9115V76.7117H77.8639ZM94.3788 61.6179L102.644 76.7117H96.8944L88.7922 61.6179H94.3788ZM113.94 43.2571V76.7117H108.892V43.2571H113.94Z" fill="black"/>
                <path d="M126.969 51.7117V43.7117H129.672C130.299 43.7117 130.813 43.825 131.211 44.0515C131.612 44.2755 131.909 44.5789 132.102 44.9617C132.294 45.3445 132.391 45.7716 132.391 46.2429C132.391 46.7143 132.294 47.1427 132.102 47.5281C131.911 47.9135 131.617 48.2208 131.219 48.45C130.82 48.6765 130.31 48.7898 129.688 48.7898H127.75V47.9304H129.656C130.086 47.9304 130.431 47.8562 130.691 47.7078C130.952 47.5593 131.141 47.3588 131.258 47.1062C131.378 46.851 131.438 46.5632 131.438 46.2429C131.438 45.9226 131.378 45.6361 131.258 45.3835C131.141 45.1309 130.951 44.933 130.688 44.7898C130.424 44.644 130.076 44.571 129.641 44.571H127.938V51.7117H126.969ZM134.156 51.7117V45.7117H135.047V46.6179H135.109C135.219 46.321 135.417 46.0802 135.703 45.8953C135.99 45.7104 136.312 45.6179 136.672 45.6179C136.74 45.6179 136.824 45.6192 136.926 45.6218C137.027 45.6244 137.104 45.6283 137.156 45.6335V46.571C137.125 46.5632 137.053 46.5515 136.941 46.5359C136.832 46.5177 136.716 46.5085 136.594 46.5085C136.302 46.5085 136.042 46.5697 135.812 46.6921C135.586 46.8119 135.406 46.9786 135.273 47.1921C135.143 47.4031 135.078 47.644 135.078 47.9148V51.7117H134.156ZM138.579 51.7117V45.7117H139.501V51.7117H138.579ZM139.048 44.7117C138.868 44.7117 138.713 44.6505 138.583 44.5281C138.455 44.4057 138.391 44.2585 138.391 44.0867C138.391 43.9148 138.455 43.7677 138.583 43.6453C138.713 43.5229 138.868 43.4617 139.048 43.4617C139.227 43.4617 139.381 43.5229 139.509 43.6453C139.639 43.7677 139.704 43.9148 139.704 44.0867C139.704 44.2585 139.639 44.4057 139.509 44.5281C139.381 44.6505 139.227 44.7117 139.048 44.7117ZM142.441 48.1023V51.7117H141.519V45.7117H142.41V46.6492H142.488C142.629 46.3445 142.842 46.0997 143.129 45.9148C143.415 45.7273 143.785 45.6335 144.238 45.6335C144.644 45.6335 145 45.7169 145.304 45.8835C145.609 46.0476 145.846 46.2976 146.015 46.6335C146.185 46.9669 146.269 47.3888 146.269 47.8992V51.7117H145.347V47.9617C145.347 47.4903 145.225 47.1231 144.98 46.8601C144.735 46.5945 144.4 46.4617 143.972 46.4617C143.678 46.4617 143.415 46.5255 143.183 46.6531C142.954 46.7807 142.773 46.9669 142.64 47.2117C142.508 47.4565 142.441 47.7533 142.441 48.1023ZM150.721 51.8367C150.159 51.8367 149.674 51.7039 149.268 51.4382C148.862 51.1726 148.549 50.8067 148.331 50.3406C148.112 49.8744 148.003 49.3419 148.003 48.7429C148.003 48.1335 148.115 47.5958 148.339 47.1296C148.565 46.6609 148.88 46.295 149.284 46.032C149.69 45.7664 150.164 45.6335 150.706 45.6335C151.128 45.6335 151.508 45.7117 151.846 45.8679C152.185 46.0242 152.462 46.2429 152.678 46.5242C152.895 46.8054 153.029 47.1335 153.081 47.5085H152.159C152.089 47.2351 151.932 46.9929 151.69 46.782C151.451 46.5684 151.128 46.4617 150.721 46.4617C150.362 46.4617 150.047 46.5554 149.776 46.7429C149.508 46.9278 149.298 47.1895 149.147 47.5281C148.999 47.864 148.924 48.2585 148.924 48.7117C148.924 49.1752 148.997 49.5789 149.143 49.9226C149.292 50.2664 149.5 50.5333 149.768 50.7234C150.039 50.9135 150.357 51.0085 150.721 51.0085C150.961 51.0085 151.178 50.9669 151.374 50.8835C151.569 50.8002 151.734 50.6804 151.87 50.5242C152.005 50.3679 152.102 50.1804 152.159 49.9617H153.081C153.029 50.3158 152.9 50.6348 152.694 50.9187C152.491 51.2 152.221 51.4239 151.885 51.5906C151.552 51.7546 151.164 51.8367 150.721 51.8367ZM154.758 51.7117V45.7117H155.68V51.7117H154.758ZM155.227 44.7117C155.047 44.7117 154.893 44.6505 154.762 44.5281C154.635 44.4057 154.571 44.2585 154.571 44.0867C154.571 43.9148 154.635 43.7677 154.762 43.6453C154.893 43.5229 155.047 43.4617 155.227 43.4617C155.407 43.4617 155.56 43.5229 155.688 43.6453C155.818 43.7677 155.883 43.9148 155.883 44.0867C155.883 44.2585 155.818 44.4057 155.688 44.5281C155.56 44.6505 155.407 44.7117 155.227 44.7117ZM157.699 53.9617V45.7117H158.589V46.6648H158.699C158.766 46.5606 158.86 46.4278 158.98 46.2664C159.102 46.1023 159.277 45.9565 159.503 45.8289C159.733 45.6986 160.042 45.6335 160.433 45.6335C160.938 45.6335 161.384 45.7598 161.769 46.0125C162.154 46.2651 162.455 46.6231 162.671 47.0867C162.888 47.5502 162.996 48.0971 162.996 48.7273C162.996 49.3627 162.888 49.9135 162.671 50.3796C162.455 50.8432 162.156 51.2026 161.773 51.4578C161.39 51.7104 160.949 51.8367 160.449 51.8367C160.063 51.8367 159.755 51.7729 159.523 51.6453C159.291 51.5151 159.113 51.3679 158.988 51.2039C158.863 51.0372 158.766 50.8992 158.699 50.7898H158.621V53.9617H157.699ZM158.605 48.7117C158.605 49.1648 158.671 49.5645 158.804 49.9109C158.937 50.2546 159.131 50.5242 159.386 50.7195C159.641 50.9122 159.954 51.0085 160.324 51.0085C160.709 51.0085 161.031 50.907 161.289 50.7039C161.549 50.4981 161.744 50.2221 161.875 49.8757C162.007 49.5268 162.074 49.1388 162.074 48.7117C162.074 48.2898 162.009 47.9096 161.878 47.571C161.751 47.2299 161.557 46.9604 161.296 46.7625C161.039 46.5619 160.714 46.4617 160.324 46.4617C159.949 46.4617 159.634 46.5567 159.378 46.7468C159.123 46.9343 158.931 47.1973 158.8 47.5359C158.67 47.8718 158.605 48.2638 158.605 48.7117ZM165.654 43.7117V51.7117H164.732V43.7117H165.654ZM170.188 51.8367C169.61 51.8367 169.111 51.7091 168.692 51.4539C168.275 51.196 167.953 50.8367 167.727 50.3757C167.503 49.9122 167.391 49.3731 167.391 48.7585C167.391 48.144 167.503 47.6023 167.727 47.1335C167.953 46.6622 168.269 46.295 168.672 46.032C169.078 45.7664 169.552 45.6335 170.094 45.6335C170.407 45.6335 170.715 45.6856 171.02 45.7898C171.325 45.894 171.602 46.0632 171.852 46.2976C172.102 46.5294 172.301 46.8367 172.45 47.2195C172.598 47.6023 172.672 48.0736 172.672 48.6335V49.0242H168.047V48.2273H171.735C171.735 47.8888 171.667 47.5867 171.532 47.321C171.399 47.0554 171.209 46.8458 170.961 46.6921C170.716 46.5385 170.427 46.4617 170.094 46.4617C169.727 46.4617 169.409 46.5528 169.141 46.7351C168.875 46.9148 168.671 47.1492 168.528 47.4382C168.384 47.7273 168.313 48.0372 168.313 48.3679V48.8992C168.313 49.3523 168.391 49.7364 168.547 50.0515C168.706 50.364 168.926 50.6023 169.207 50.7664C169.489 50.9278 169.815 51.0085 170.188 51.0085C170.43 51.0085 170.649 50.9747 170.844 50.907C171.042 50.8367 171.213 50.7325 171.356 50.5945C171.499 50.4539 171.61 50.2794 171.688 50.071L172.578 50.321C172.485 50.6231 172.327 50.8888 172.106 51.1179C171.884 51.3445 171.611 51.5216 171.286 51.6492C170.96 51.7742 170.594 51.8367 170.188 51.8367ZM178.655 47.0554L177.826 47.2898C177.774 47.1518 177.698 47.0177 177.596 46.8875C177.497 46.7546 177.362 46.6453 177.19 46.5593C177.018 46.4734 176.798 46.4304 176.53 46.4304C176.162 46.4304 175.856 46.5151 175.612 46.6843C175.369 46.851 175.248 47.0632 175.248 47.321C175.248 47.5502 175.332 47.7312 175.498 47.864C175.665 47.9968 175.925 48.1075 176.28 48.196L177.17 48.4148C177.707 48.545 178.106 48.7442 178.369 49.0125C178.632 49.2781 178.764 49.6205 178.764 50.0398C178.764 50.3835 178.665 50.6908 178.467 50.9617C178.272 51.2325 177.998 51.446 177.647 51.6023C177.295 51.7585 176.886 51.8367 176.42 51.8367C175.808 51.8367 175.302 51.7039 174.901 51.4382C174.5 51.1726 174.246 50.7846 174.139 50.2742L175.014 50.0554C175.097 50.3783 175.255 50.6205 175.487 50.782C175.721 50.9434 176.027 51.0242 176.405 51.0242C176.834 51.0242 177.175 50.933 177.428 50.7507C177.683 50.5658 177.811 50.3445 177.811 50.0867C177.811 49.8783 177.738 49.7039 177.592 49.5632C177.446 49.42 177.222 49.3132 176.92 49.2429L175.92 49.0085C175.371 48.8783 174.967 48.6765 174.709 48.4031C174.454 48.127 174.326 47.782 174.326 47.3679C174.326 47.0294 174.421 46.7299 174.612 46.4695C174.804 46.2091 175.066 46.0046 175.397 45.8562C175.73 45.7078 176.108 45.6335 176.53 45.6335C177.123 45.6335 177.589 45.7638 177.928 46.0242C178.269 46.2846 178.511 46.6283 178.655 47.0554ZM186.577 45.7117V46.4929H183.343V45.7117H186.577ZM184.312 51.7117V44.8835C184.312 44.5398 184.392 44.2533 184.554 44.0242C184.715 43.795 184.925 43.6231 185.183 43.5085C185.441 43.394 185.713 43.3367 185.999 43.3367C186.226 43.3367 186.411 43.3549 186.554 43.3914C186.697 43.4278 186.804 43.4617 186.874 43.4929L186.609 44.2898C186.562 44.2742 186.497 44.2546 186.413 44.2312C186.332 44.2078 186.226 44.196 186.093 44.196C185.788 44.196 185.568 44.2729 185.433 44.4265C185.3 44.5802 185.234 44.8054 185.234 45.1023V51.7117H184.312ZM190.39 51.8367C189.848 51.8367 189.373 51.7078 188.964 51.45C188.558 51.1921 188.24 50.8315 188.011 50.3679C187.784 49.9044 187.671 49.3627 187.671 48.7429C187.671 48.1179 187.784 47.5723 188.011 47.1062C188.24 46.6401 188.558 46.2781 188.964 46.0203C189.373 45.7625 189.848 45.6335 190.39 45.6335C190.931 45.6335 191.405 45.7625 191.812 46.0203C192.22 46.2781 192.538 46.6401 192.765 47.1062C192.994 47.5723 193.108 48.1179 193.108 48.7429C193.108 49.3627 192.994 49.9044 192.765 50.3679C192.538 50.8315 192.22 51.1921 191.812 51.45C191.405 51.7078 190.931 51.8367 190.39 51.8367ZM190.39 51.0085C190.801 51.0085 191.14 50.9031 191.405 50.6921C191.671 50.4812 191.868 50.2039 191.995 49.8601C192.123 49.5164 192.187 49.144 192.187 48.7429C192.187 48.3419 192.123 47.9682 191.995 47.6218C191.868 47.2755 191.671 46.9955 191.405 46.782C191.14 46.5684 190.801 46.4617 190.39 46.4617C189.978 46.4617 189.64 46.5684 189.374 46.782C189.108 46.9955 188.912 47.2755 188.784 47.6218C188.657 47.9682 188.593 48.3419 188.593 48.7429C188.593 49.144 188.657 49.5164 188.784 49.8601C188.912 50.2039 189.108 50.4812 189.374 50.6921C189.64 50.9031 189.978 51.0085 190.39 51.0085ZM194.846 51.7117V45.7117H195.736V46.6179H195.799C195.908 46.321 196.106 46.0802 196.393 45.8953C196.679 45.7104 197.002 45.6179 197.361 45.6179C197.429 45.6179 197.514 45.6192 197.615 45.6218C197.717 45.6244 197.794 45.6283 197.846 45.6335V46.571C197.814 46.5632 197.743 46.5515 197.631 46.5359C197.521 46.5177 197.406 46.5085 197.283 46.5085C196.991 46.5085 196.731 46.5697 196.502 46.6921C196.275 46.8119 196.096 46.9786 195.963 47.1921C195.833 47.4031 195.768 47.644 195.768 47.9148V51.7117H194.846ZM126.969 65.7117V57.7117H129.672C130.297 57.7117 130.81 57.8184 131.211 58.032C131.612 58.2429 131.909 58.5333 132.102 58.9031C132.294 59.2729 132.391 59.6934 132.391 60.1648C132.391 60.6361 132.294 61.0541 132.102 61.4187C131.909 61.7833 131.613 62.0697 131.215 62.2781C130.816 62.4838 130.307 62.5867 129.688 62.5867H127.5V61.7117H129.656C130.083 61.7117 130.427 61.6492 130.688 61.5242C130.951 61.3992 131.141 61.2221 131.258 60.9929C131.378 60.7611 131.438 60.4851 131.438 60.1648C131.438 59.8445 131.378 59.5645 131.258 59.325C131.138 59.0854 130.947 58.9005 130.684 58.7703C130.421 58.6375 130.073 58.571 129.641 58.571H127.938V65.7117H126.969ZM130.734 62.1179L132.703 65.7117H131.578L129.641 62.1179H130.734ZM136.661 65.8367C136.083 65.8367 135.584 65.7091 135.165 65.4539C134.748 65.196 134.427 64.8367 134.2 64.3757C133.976 63.9122 133.864 63.3731 133.864 62.7585C133.864 62.144 133.976 61.6023 134.2 61.1335C134.427 60.6622 134.742 60.295 135.145 60.032C135.552 59.7664 136.026 59.6335 136.567 59.6335C136.88 59.6335 137.188 59.6856 137.493 59.7898C137.798 59.894 138.075 60.0632 138.325 60.2976C138.575 60.5294 138.774 60.8367 138.923 61.2195C139.071 61.6023 139.145 62.0736 139.145 62.6335V63.0242H134.52V62.2273H138.208C138.208 61.8888 138.14 61.5867 138.005 61.321C137.872 61.0554 137.682 60.8458 137.434 60.6921C137.19 60.5385 136.901 60.4617 136.567 60.4617C136.2 60.4617 135.882 60.5528 135.614 60.7351C135.349 60.9148 135.144 61.1492 135.001 61.4382C134.858 61.7273 134.786 62.0372 134.786 62.3679V62.8992C134.786 63.3523 134.864 63.7364 135.02 64.0515C135.179 64.364 135.399 64.6023 135.681 64.7664C135.962 64.9278 136.289 65.0085 136.661 65.0085C136.903 65.0085 137.122 64.9747 137.317 64.907C137.515 64.8367 137.686 64.7325 137.829 64.5945C137.972 64.4539 138.083 64.2794 138.161 64.071L139.052 64.321C138.958 64.6231 138.8 64.8888 138.579 65.1179C138.358 65.3445 138.084 65.5216 137.759 65.6492C137.433 65.7742 137.067 65.8367 136.661 65.8367ZM145.128 61.0554L144.3 61.2898C144.248 61.1518 144.171 61.0177 144.069 60.8875C143.97 60.7546 143.835 60.6453 143.663 60.5593C143.491 60.4734 143.271 60.4304 143.003 60.4304C142.636 60.4304 142.33 60.5151 142.085 60.6843C141.843 60.851 141.722 61.0632 141.722 61.321C141.722 61.5502 141.805 61.7312 141.972 61.864C142.138 61.9968 142.399 62.1075 142.753 62.196L143.643 62.4148C144.18 62.545 144.58 62.7442 144.843 63.0125C145.106 63.2781 145.237 63.6205 145.237 64.0398C145.237 64.3835 145.138 64.6908 144.94 64.9617C144.745 65.2325 144.472 65.446 144.12 65.6023C143.768 65.7585 143.36 65.8367 142.893 65.8367C142.281 65.8367 141.775 65.7039 141.374 65.4382C140.973 65.1726 140.719 64.7846 140.612 64.2742L141.487 64.0554C141.57 64.3783 141.728 64.6205 141.96 64.782C142.194 64.9434 142.5 65.0242 142.878 65.0242C143.307 65.0242 143.649 64.933 143.901 64.7507C144.156 64.5658 144.284 64.3445 144.284 64.0867C144.284 63.8783 144.211 63.7039 144.065 63.5632C143.919 63.42 143.695 63.3132 143.393 63.2429L142.393 63.0085C141.844 62.8783 141.44 62.6765 141.182 62.4031C140.927 62.127 140.8 61.782 140.8 61.3679C140.8 61.0294 140.895 60.7299 141.085 60.4695C141.278 60.2091 141.539 60.0046 141.87 59.8562C142.203 59.7078 142.581 59.6335 143.003 59.6335C143.597 59.6335 144.063 59.7638 144.401 60.0242C144.742 60.2846 144.985 60.6283 145.128 61.0554ZM146.955 67.9617V59.7117H147.845V60.6648H147.955C148.023 60.5606 148.116 60.4278 148.236 60.2664C148.358 60.1023 148.533 59.9565 148.76 59.8289C148.989 59.6986 149.299 59.6335 149.689 59.6335C150.194 59.6335 150.64 59.7598 151.025 60.0125C151.411 60.2651 151.711 60.6231 151.928 61.0867C152.144 61.5502 152.252 62.0971 152.252 62.7273C152.252 63.3627 152.144 63.9135 151.928 64.3796C151.711 64.8432 151.412 65.2026 151.029 65.4578C150.646 65.7104 150.205 65.8367 149.705 65.8367C149.319 65.8367 149.011 65.7729 148.779 65.6453C148.547 65.5151 148.369 65.3679 148.244 65.2039C148.119 65.0372 148.023 64.8992 147.955 64.7898H147.877V67.9617H146.955ZM147.861 62.7117C147.861 63.1648 147.927 63.5645 148.06 63.9109C148.193 64.2546 148.387 64.5242 148.642 64.7195C148.898 64.9122 149.21 65.0085 149.58 65.0085C149.965 65.0085 150.287 64.907 150.545 64.7039C150.805 64.4981 151 64.2221 151.131 63.8757C151.263 63.5268 151.33 63.1388 151.33 62.7117C151.33 62.2898 151.265 61.9096 151.135 61.571C151.007 61.2299 150.813 60.9604 150.552 60.7625C150.295 60.5619 149.97 60.4617 149.58 60.4617C149.205 60.4617 148.89 60.5567 148.635 60.7468C148.379 60.9343 148.187 61.1973 148.056 61.5359C147.926 61.8718 147.861 62.2638 147.861 62.7117ZM156.425 65.8367C155.884 65.8367 155.409 65.7078 155 65.45C154.593 65.1921 154.276 64.8315 154.047 64.3679C153.82 63.9044 153.707 63.3627 153.707 62.7429C153.707 62.1179 153.82 61.5723 154.047 61.1062C154.276 60.6401 154.593 60.2781 155 60.0203C155.409 59.7625 155.884 59.6335 156.425 59.6335C156.967 59.6335 157.441 59.7625 157.847 60.0203C158.256 60.2781 158.574 60.6401 158.8 61.1062C159.03 61.5723 159.144 62.1179 159.144 62.7429C159.144 63.3627 159.03 63.9044 158.8 64.3679C158.574 64.8315 158.256 65.1921 157.847 65.45C157.441 65.7078 156.967 65.8367 156.425 65.8367ZM156.425 65.0085C156.837 65.0085 157.175 64.9031 157.441 64.6921C157.707 64.4812 157.903 64.2039 158.031 63.8601C158.159 63.5164 158.222 63.144 158.222 62.7429C158.222 62.3419 158.159 61.9682 158.031 61.6218C157.903 61.2755 157.707 60.9955 157.441 60.782C157.175 60.5684 156.837 60.4617 156.425 60.4617C156.014 60.4617 155.675 60.5684 155.41 60.782C155.144 60.9955 154.948 61.2755 154.82 61.6218C154.692 61.9682 154.629 62.3419 154.629 62.7429C154.629 63.144 154.692 63.5164 154.82 63.8601C154.948 64.2039 155.144 64.4812 155.41 64.6921C155.675 64.9031 156.014 65.0085 156.425 65.0085ZM161.803 62.1023V65.7117H160.881V59.7117H161.772V60.6492H161.85C161.991 60.3445 162.204 60.0997 162.491 59.9148C162.777 59.7273 163.147 59.6335 163.6 59.6335C164.006 59.6335 164.362 59.7169 164.667 59.8835C164.971 60.0476 165.208 60.2976 165.378 60.6335C165.547 60.9669 165.631 61.3888 165.631 61.8992V65.7117H164.71V61.9617C164.71 61.4903 164.587 61.1231 164.342 60.8601C164.098 60.5945 163.762 60.4617 163.335 60.4617C163.04 60.4617 162.777 60.5255 162.546 60.6531C162.316 60.7807 162.135 60.9669 162.003 61.2117C161.87 61.4565 161.803 61.7533 161.803 62.1023ZM171.896 61.0554L171.068 61.2898C171.016 61.1518 170.939 61.0177 170.837 60.8875C170.738 60.7546 170.603 60.6453 170.431 60.5593C170.259 60.4734 170.039 60.4304 169.771 60.4304C169.404 60.4304 169.098 60.5151 168.853 60.6843C168.611 60.851 168.49 61.0632 168.49 61.321C168.49 61.5502 168.573 61.7312 168.74 61.864C168.906 61.9968 169.167 62.1075 169.521 62.196L170.412 62.4148C170.948 62.545 171.348 62.7442 171.611 63.0125C171.874 63.2781 172.005 63.6205 172.005 64.0398C172.005 64.3835 171.906 64.6908 171.709 64.9617C171.513 65.2325 171.24 65.446 170.888 65.6023C170.537 65.7585 170.128 65.8367 169.662 65.8367C169.05 65.8367 168.543 65.7039 168.142 65.4382C167.741 65.1726 167.487 64.7846 167.38 64.2742L168.255 64.0554C168.339 64.3783 168.496 64.6205 168.728 64.782C168.962 64.9434 169.268 65.0242 169.646 65.0242C170.076 65.0242 170.417 64.933 170.669 64.7507C170.925 64.5658 171.052 64.3445 171.052 64.0867C171.052 63.8783 170.979 63.7039 170.834 63.5632C170.688 63.42 170.464 63.3132 170.162 63.2429L169.162 63.0085C168.612 62.8783 168.209 62.6765 167.951 62.4031C167.695 62.127 167.568 61.782 167.568 61.3679C167.568 61.0294 167.663 60.7299 167.853 60.4695C168.046 60.2091 168.307 60.0046 168.638 59.8562C168.972 59.7078 169.349 59.6335 169.771 59.6335C170.365 59.6335 170.831 59.7638 171.169 60.0242C171.511 60.2846 171.753 60.6283 171.896 61.0554ZM173.723 65.7117V59.7117H174.645V65.7117H173.723ZM174.192 58.7117C174.012 58.7117 173.857 58.6505 173.727 58.5281C173.599 58.4057 173.536 58.2585 173.536 58.0867C173.536 57.9148 173.599 57.7677 173.727 57.6453C173.857 57.5229 174.012 57.4617 174.192 57.4617C174.372 57.4617 174.525 57.5229 174.653 57.6453C174.783 57.7677 174.848 57.9148 174.848 58.0867C174.848 58.2585 174.783 58.4057 174.653 58.5281C174.525 58.6505 174.372 58.7117 174.192 58.7117ZM176.788 65.7117V57.7117H177.71V60.6648H177.788C177.856 60.5606 177.95 60.4278 178.07 60.2664C178.192 60.1023 178.367 59.9565 178.593 59.8289C178.822 59.6986 179.132 59.6335 179.523 59.6335C180.028 59.6335 180.473 59.7598 180.859 60.0125C181.244 60.2651 181.545 60.6231 181.761 61.0867C181.977 61.5502 182.085 62.0971 182.085 62.7273C182.085 63.3627 181.977 63.9135 181.761 64.3796C181.545 64.8432 181.245 65.2026 180.863 65.4578C180.48 65.7104 180.038 65.8367 179.538 65.8367C179.153 65.8367 178.844 65.7729 178.613 65.6453C178.381 65.5151 178.202 65.3679 178.077 65.2039C177.952 65.0372 177.856 64.8992 177.788 64.7898H177.679V65.7117H176.788ZM177.695 62.7117C177.695 63.1648 177.761 63.5645 177.894 63.9109C178.027 64.2546 178.221 64.5242 178.476 64.7195C178.731 64.9122 179.044 65.0085 179.413 65.0085C179.799 65.0085 180.12 64.907 180.378 64.7039C180.639 64.4981 180.834 64.2221 180.964 63.8757C181.097 63.5268 181.163 63.1388 181.163 62.7117C181.163 62.2898 181.098 61.9096 180.968 61.571C180.841 61.2299 180.647 60.9604 180.386 60.7625C180.128 60.5619 179.804 60.4617 179.413 60.4617C179.038 60.4617 178.723 60.5567 178.468 60.7468C178.213 60.9343 178.02 61.1973 177.89 61.5359C177.76 61.8718 177.695 62.2638 177.695 62.7117ZM184.747 57.7117V65.7117H183.825V57.7117H184.747ZM189.281 65.8367C188.703 65.8367 188.205 65.7091 187.785 65.4539C187.369 65.196 187.047 64.8367 186.821 64.3757C186.597 63.9122 186.485 63.3731 186.485 62.7585C186.485 62.144 186.597 61.6023 186.821 61.1335C187.047 60.6622 187.362 60.295 187.766 60.032C188.172 59.7664 188.646 59.6335 189.188 59.6335C189.5 59.6335 189.809 59.6856 190.113 59.7898C190.418 59.894 190.696 60.0632 190.946 60.2976C191.196 60.5294 191.395 60.8367 191.543 61.2195C191.692 61.6023 191.766 62.0736 191.766 62.6335V63.0242H187.141V62.2273H190.828C190.828 61.8888 190.761 61.5867 190.625 61.321C190.492 61.0554 190.302 60.8458 190.055 60.6921C189.81 60.5385 189.521 60.4617 189.188 60.4617C188.821 60.4617 188.503 60.5528 188.235 60.7351C187.969 60.9148 187.765 61.1492 187.621 61.4382C187.478 61.7273 187.406 62.0372 187.406 62.3679V62.8992C187.406 63.3523 187.485 63.7364 187.641 64.0515C187.8 64.364 188.02 64.6023 188.301 64.7664C188.582 64.9278 188.909 65.0085 189.281 65.0085C189.524 65.0085 189.742 64.9747 189.938 64.907C190.136 64.8367 190.306 64.7325 190.449 64.5945C190.593 64.4539 190.703 64.2794 190.781 64.071L191.672 64.321C191.578 64.6231 191.421 64.8888 191.199 65.1179C190.978 65.3445 190.705 65.5216 190.379 65.6492C190.054 65.7742 189.688 65.8367 189.281 65.8367ZM127.938 71.7117V79.7117H126.969V71.7117H127.938ZM131.007 76.1023V79.7117H130.085V73.7117H130.976V74.6492H131.054C131.194 74.3445 131.408 74.0997 131.694 73.9148C131.981 73.7273 132.351 73.6335 132.804 73.6335C133.21 73.6335 133.565 73.7169 133.87 73.8835C134.175 74.0476 134.412 74.2976 134.581 74.6335C134.75 74.9669 134.835 75.3888 134.835 75.8992V79.7117H133.913V75.9617C133.913 75.4903 133.791 75.1231 133.546 74.8601C133.301 74.5945 132.965 74.4617 132.538 74.4617C132.244 74.4617 131.981 74.5255 131.749 74.6531C131.52 74.7807 131.339 74.9669 131.206 75.2117C131.073 75.4565 131.007 75.7533 131.007 76.1023ZM141.541 73.7117L139.322 79.7117H138.385L136.166 73.7117H137.166L138.822 78.4929H138.885L140.541 73.7117H141.541ZM145.388 79.8367C144.81 79.8367 144.312 79.7091 143.892 79.4539C143.476 79.196 143.154 78.8367 142.927 78.3757C142.704 77.9122 142.592 77.3731 142.592 76.7585C142.592 76.144 142.704 75.6023 142.927 75.1335C143.154 74.6622 143.469 74.295 143.873 74.032C144.279 73.7664 144.753 73.6335 145.295 73.6335C145.607 73.6335 145.916 73.6856 146.22 73.7898C146.525 73.894 146.802 74.0632 147.052 74.2976C147.302 74.5294 147.502 74.8367 147.65 75.2195C147.799 75.6023 147.873 76.0736 147.873 76.6335V77.0242H143.248V76.2273H146.935C146.935 75.8888 146.868 75.5867 146.732 75.321C146.599 75.0554 146.409 74.8458 146.162 74.6921C145.917 74.5385 145.628 74.4617 145.295 74.4617C144.927 74.4617 144.61 74.5528 144.342 74.7351C144.076 74.9148 143.872 75.1492 143.728 75.4382C143.585 75.7273 143.513 76.0372 143.513 76.3679V76.8992C143.513 77.3523 143.592 77.7364 143.748 78.0515C143.907 78.364 144.127 78.6023 144.408 78.7664C144.689 78.9278 145.016 79.0085 145.388 79.0085C145.631 79.0085 145.849 78.9747 146.045 78.907C146.243 78.8367 146.413 78.7325 146.556 78.5945C146.7 78.4539 146.81 78.2794 146.888 78.071L147.779 78.321C147.685 78.6231 147.528 78.8888 147.306 79.1179C147.085 79.3445 146.812 79.5216 146.486 79.6492C146.161 79.7742 145.795 79.8367 145.388 79.8367ZM153.855 75.0554L153.027 75.2898C152.975 75.1518 152.898 75.0177 152.797 74.8875C152.698 74.7546 152.562 74.6453 152.39 74.5593C152.218 74.4734 151.998 74.4304 151.73 74.4304C151.363 74.4304 151.057 74.5151 150.812 74.6843C150.57 74.851 150.449 75.0632 150.449 75.321C150.449 75.5502 150.532 75.7312 150.699 75.864C150.866 75.9968 151.126 76.1075 151.48 76.196L152.371 76.4148C152.907 76.545 153.307 76.7442 153.57 77.0125C153.833 77.2781 153.965 77.6205 153.965 78.0398C153.965 78.3835 153.866 78.6908 153.668 78.9617C153.472 79.2325 153.199 79.446 152.847 79.6023C152.496 79.7585 152.087 79.8367 151.621 79.8367C151.009 79.8367 150.502 79.7039 150.101 79.4382C149.7 79.1726 149.446 78.7846 149.34 78.2742L150.215 78.0554C150.298 78.3783 150.455 78.6205 150.687 78.782C150.922 78.9434 151.228 79.0242 151.605 79.0242C152.035 79.0242 152.376 78.933 152.629 78.7507C152.884 78.5658 153.011 78.3445 153.011 78.0867C153.011 77.8783 152.938 77.7039 152.793 77.5632C152.647 77.42 152.423 77.3132 152.121 77.2429L151.121 77.0085C150.571 76.8783 150.168 76.6765 149.91 76.4031C149.655 76.127 149.527 75.782 149.527 75.3679C149.527 75.0294 149.622 74.7299 149.812 74.4695C150.005 74.2091 150.267 74.0046 150.597 73.8562C150.931 73.7078 151.308 73.6335 151.73 73.6335C152.324 73.6335 152.79 73.7638 153.129 74.0242C153.47 74.2846 153.712 74.6283 153.855 75.0554ZM158.292 73.7117V74.4929H155.182V73.7117H158.292ZM156.088 72.2742H157.01V77.9929C157.01 78.2533 157.048 78.4486 157.124 78.5789C157.202 78.7065 157.301 78.7924 157.421 78.8367C157.543 78.8783 157.672 78.8992 157.807 78.8992C157.909 78.8992 157.992 78.894 158.057 78.8835C158.122 78.8705 158.174 78.8601 158.213 78.8523L158.401 79.6804C158.338 79.7039 158.251 79.7273 158.139 79.7507C158.027 79.7768 157.885 79.7898 157.713 79.7898C157.453 79.7898 157.198 79.7338 156.948 79.6218C156.7 79.5098 156.495 79.3393 156.331 79.1101C156.169 78.8809 156.088 78.5919 156.088 78.2429V72.2742ZM160.008 79.7117V73.7117H160.899V74.6492H160.977C161.102 74.3289 161.304 74.0802 161.583 73.9031C161.861 73.7234 162.196 73.6335 162.586 73.6335C162.982 73.6335 163.312 73.7234 163.575 73.9031C163.84 74.0802 164.047 74.3289 164.196 74.6492H164.258C164.412 74.3393 164.642 74.0932 164.95 73.9109C165.257 73.726 165.626 73.6335 166.055 73.6335C166.592 73.6335 167.03 73.8015 167.372 74.1375C167.713 74.4708 167.883 74.9903 167.883 75.696V79.7117H166.961V75.696C166.961 75.2533 166.84 74.9369 166.598 74.7468C166.356 74.5567 166.071 74.4617 165.743 74.4617C165.321 74.4617 164.994 74.5893 164.762 74.8445C164.53 75.0971 164.415 75.4174 164.415 75.8054V79.7117H163.477V75.6023C163.477 75.2611 163.366 74.9864 163.145 74.7781C162.924 74.5671 162.639 74.4617 162.29 74.4617C162.05 74.4617 161.826 74.5255 161.618 74.6531C161.412 74.7807 161.245 74.9578 161.118 75.1843C160.993 75.4083 160.93 75.6674 160.93 75.9617V79.7117H160.008ZM172.414 79.8367C171.836 79.8367 171.338 79.7091 170.918 79.4539C170.502 79.196 170.18 78.8367 169.954 78.3757C169.73 77.9122 169.618 77.3731 169.618 76.7585C169.618 76.144 169.73 75.6023 169.954 75.1335C170.18 74.6622 170.495 74.295 170.899 74.032C171.305 73.7664 171.779 73.6335 172.321 73.6335C172.633 73.6335 172.942 73.6856 173.247 73.7898C173.551 73.894 173.829 74.0632 174.079 74.2976C174.329 74.5294 174.528 74.8367 174.676 75.2195C174.825 75.6023 174.899 76.0736 174.899 76.6335V77.0242H170.274V76.2273H173.961C173.961 75.8888 173.894 75.5867 173.758 75.321C173.625 75.0554 173.435 74.8458 173.188 74.6921C172.943 74.5385 172.654 74.4617 172.321 74.4617C171.954 74.4617 171.636 74.5528 171.368 74.7351C171.102 74.9148 170.898 75.1492 170.754 75.4382C170.611 75.7273 170.539 76.0372 170.539 76.3679V76.8992C170.539 77.3523 170.618 77.7364 170.774 78.0515C170.933 78.364 171.153 78.6023 171.434 78.7664C171.715 78.9278 172.042 79.0085 172.414 79.0085C172.657 79.0085 172.875 78.9747 173.071 78.907C173.269 78.8367 173.439 78.7325 173.582 78.5945C173.726 78.4539 173.836 78.2794 173.914 78.071L174.805 78.321C174.711 78.6231 174.554 78.8888 174.332 79.1179C174.111 79.3445 173.838 79.5216 173.512 79.6492C173.187 79.7742 172.821 79.8367 172.414 79.8367ZM177.553 76.1023V79.7117H176.631V73.7117H177.522V74.6492H177.6C177.741 74.3445 177.954 74.0997 178.241 73.9148C178.527 73.7273 178.897 73.6335 179.35 73.6335C179.756 73.6335 180.112 73.7169 180.416 73.8835C180.721 74.0476 180.958 74.2976 181.127 74.6335C181.297 74.9669 181.381 75.3888 181.381 75.8992V79.7117H180.459V75.9617C180.459 75.4903 180.337 75.1231 180.092 74.8601C179.847 74.5945 179.511 74.4617 179.084 74.4617C178.79 74.4617 178.527 74.5255 178.295 74.6531C178.066 74.7807 177.885 74.9669 177.752 75.2117C177.619 75.4565 177.553 75.7533 177.553 76.1023ZM186.005 73.7117V74.4929H182.896V73.7117H186.005ZM183.802 72.2742H184.724V77.9929C184.724 78.2533 184.762 78.4486 184.837 78.5789C184.915 78.7065 185.014 78.7924 185.134 78.8367C185.256 78.8783 185.385 78.8992 185.521 78.8992C185.622 78.8992 185.706 78.894 185.771 78.8835C185.836 78.8705 185.888 78.8601 185.927 78.8523L186.115 79.6804C186.052 79.7039 185.965 79.7273 185.853 79.7507C185.741 79.7768 185.599 79.7898 185.427 79.7898C185.167 79.7898 184.911 79.7338 184.661 79.6218C184.414 79.5098 184.208 79.3393 184.044 79.1101C183.883 78.8809 183.802 78.5919 183.802 78.2429V72.2742Z" fill="black"/>
                <line x1="121.5" y1="77.7175" x2="121.5" y2="41.7175" stroke="black"/>
                <path d="M56.3565 8.20031C56.3603 7.62834 56.1747 7.19084 55.7997 6.88781C55.4285 6.58478 54.9095 6.43326 54.2429 6.43326C53.7656 6.43326 53.3395 6.50902 52.9645 6.66053C52.5932 6.80826 52.2902 7.01281 52.0554 7.27417C51.8243 7.53175 51.6823 7.82531 51.6292 8.15485C51.58 8.43137 51.6046 8.67 51.7031 8.87076C51.8054 9.07152 51.9512 9.24008 52.1406 9.37644C52.3338 9.50902 52.5459 9.62076 52.777 9.71167C53.008 9.79879 53.2315 9.87076 53.4474 9.92758L54.5383 10.223C54.8906 10.3139 55.2486 10.437 55.6122 10.5924C55.9758 10.7477 56.3035 10.9522 56.5951 11.206C56.8868 11.4598 57.1046 11.7742 57.2486 12.1492C57.3925 12.5242 57.4209 12.973 57.3338 13.4958C57.2201 14.1549 56.9531 14.7401 56.5326 15.2514C56.1122 15.7628 55.5573 16.1662 54.8679 16.4617C54.1785 16.7571 53.3792 16.9049 52.4701 16.9049C51.5989 16.9049 50.866 16.7666 50.2713 16.4901C49.6804 16.2136 49.2467 15.8215 48.9701 15.3139C48.6936 14.8026 48.5951 14.1965 48.6747 13.4958H50.4417C50.4001 13.9162 50.4758 14.2666 50.669 14.5469C50.866 14.8234 51.1425 15.0299 51.4986 15.1662C51.8546 15.2988 52.258 15.3651 52.7088 15.3651C53.2088 15.3651 53.6652 15.2874 54.0781 15.1321C54.491 14.973 54.8319 14.7533 55.1008 14.473C55.3698 14.1889 55.5345 13.8575 55.5951 13.4787C55.6557 13.134 55.6065 12.8518 55.4474 12.6321C55.2921 12.4124 55.0573 12.2306 54.7429 12.0867C54.4323 11.9427 54.0781 11.8158 53.6804 11.706L52.3679 11.331C51.4777 11.0772 50.8035 10.7041 50.3451 10.2117C49.8868 9.71925 49.722 9.06773 49.8508 8.25712C49.9645 7.58667 50.2448 7.00144 50.6917 6.50144C51.1387 6.00144 51.6955 5.61318 52.3622 5.33667C53.0289 5.05637 53.7523 4.91621 54.5326 4.91621C55.3205 4.91621 55.991 5.05637 56.544 5.33667C57.097 5.61697 57.5061 6.00334 57.7713 6.49576C58.0364 6.98818 58.1292 7.55637 58.0497 8.20031H56.3565ZM59.2413 16.7117L60.6959 7.9844H62.3947L60.9402 16.7117H59.2413ZM61.9004 6.62076C61.605 6.62076 61.355 6.52228 61.1504 6.32531C60.9497 6.12455 60.8569 5.88591 60.872 5.6094C60.8872 5.32909 61.0046 5.09046 61.2243 4.89349C61.444 4.69273 61.6997 4.59235 61.9913 4.59235C62.2868 4.59235 62.5349 4.69273 62.7357 4.89349C62.9364 5.09046 63.0311 5.32909 63.0197 5.6094C63.0046 5.88591 62.8872 6.12455 62.6675 6.32531C62.4516 6.52228 62.1959 6.62076 61.9004 6.62076ZM66.8193 20.1662C66.1224 20.1662 65.539 20.0753 65.0693 19.8935C64.6034 19.7117 64.236 19.4711 63.9671 19.1719C63.7019 18.8727 63.5182 18.545 63.4159 18.1889L64.9841 17.5867C65.0599 17.7533 65.1659 17.9295 65.3023 18.1151C65.4387 18.3045 65.6413 18.4655 65.9103 18.598C66.183 18.7306 66.5561 18.7969 67.0296 18.7969C67.6735 18.7969 68.236 18.6397 68.7171 18.3253C69.1981 18.0147 69.4955 17.5185 69.6091 16.8367L69.8762 15.1208H69.7682C69.6394 15.3064 69.4614 15.5128 69.2341 15.7401C69.0068 15.9674 68.7133 16.1643 68.3534 16.331C67.9936 16.4977 67.5466 16.581 67.0125 16.581C66.3231 16.581 65.7284 16.42 65.2284 16.098C64.7322 15.7723 64.3762 15.2931 64.1603 14.6605C63.9443 14.0242 63.914 13.242 64.0693 12.3139C64.2209 11.3859 64.5087 10.5905 64.933 9.92758C65.361 9.2647 65.88 8.75712 66.4898 8.40485C67.1034 8.04879 67.7606 7.87076 68.4614 7.87076C69.0031 7.87076 69.4254 7.96167 69.7284 8.14349C70.0353 8.32152 70.2625 8.52985 70.4103 8.76849C70.558 9.00712 70.6659 9.21735 70.7341 9.39917H70.8591L71.0921 7.9844H72.7568L71.2796 16.9049C71.1584 17.6549 70.8837 18.2704 70.4557 18.7514C70.0315 19.2325 69.5031 19.5886 68.8705 19.8196C68.2417 20.0507 67.558 20.1662 66.8193 20.1662ZM67.5921 15.1719C68.0769 15.1719 68.5087 15.0583 68.8875 14.831C69.2701 14.5999 69.5883 14.2704 69.8421 13.8424C70.0959 13.4105 70.272 12.8935 70.3705 12.2912C70.469 11.7041 70.4633 11.187 70.3534 10.7401C70.2474 10.2931 70.0409 9.94462 69.7341 9.69462C69.4311 9.44084 69.0353 9.31394 68.5466 9.31394C68.0315 9.31394 67.5845 9.44652 67.2057 9.71167C66.8269 9.97303 66.5182 10.3291 66.2796 10.7799C66.0447 11.2306 65.88 11.7344 65.7853 12.2912C65.6943 12.8632 65.6962 13.3651 65.7909 13.7969C65.8894 14.2287 66.0864 14.5658 66.3818 14.8083C66.6773 15.0507 67.0807 15.1719 67.5921 15.1719ZM76.6175 11.5299L75.7653 16.7117H74.0664L75.5209 7.9844H77.1516L76.913 9.40485H77.0209C77.2975 8.93894 77.6743 8.56773 78.1516 8.29121C78.6327 8.01091 79.2009 7.87076 79.8562 7.87076C80.4471 7.87076 80.9433 7.99576 81.3448 8.24576C81.7501 8.49197 82.0361 8.8594 82.2028 9.34803C82.3732 9.83667 82.3997 10.4408 82.2823 11.1605L81.3505 16.7117H79.6516L80.5437 11.3651C80.6459 10.7325 80.5626 10.2382 80.2937 9.88212C80.0285 9.52228 79.6062 9.34235 79.0266 9.34235C78.6327 9.34235 78.2671 9.42758 77.93 9.59803C77.5967 9.76849 77.3145 10.0185 77.0834 10.348C76.8562 10.6738 76.7009 11.0677 76.6175 11.5299ZM86.6203 16.9049C86.0672 16.9049 85.5843 16.8026 85.1714 16.598C84.7585 16.3897 84.4536 16.0886 84.2566 15.6946C84.0596 15.3007 84.0085 14.8177 84.1032 14.2458C84.1865 13.7533 84.3494 13.348 84.5918 13.0299C84.8381 12.7117 85.1373 12.4598 85.4896 12.2742C85.8418 12.0848 86.2244 11.9427 86.6373 11.848C87.0502 11.7533 87.4668 11.6833 87.8873 11.6378C88.4176 11.5772 88.8475 11.5261 89.1771 11.4844C89.5104 11.4427 89.7604 11.3783 89.9271 11.2912C90.0937 11.2003 90.1941 11.0526 90.2282 10.848V10.8083C90.3078 10.3158 90.2358 9.93326 90.0123 9.66053C89.7926 9.38402 89.41 9.24576 88.8646 9.24576C88.2964 9.24576 87.8191 9.37076 87.4328 9.62076C87.0502 9.87076 86.768 10.1511 86.5862 10.4617L85.0634 10.098C85.3362 9.56773 85.6828 9.1397 86.1032 8.81394C86.5274 8.4844 86.9915 8.24576 87.4953 8.09803C87.999 7.94652 88.5142 7.87076 89.0407 7.87076C89.3892 7.87076 89.7509 7.91243 90.1259 7.99576C90.5009 8.07531 90.8418 8.22303 91.1487 8.43894C91.4593 8.65485 91.6903 8.96356 91.8418 9.36508C91.9934 9.76281 92.0161 10.2799 91.91 10.9162L90.9498 16.7117H89.2907L89.4953 15.5185H89.4271C89.2831 15.7382 89.0824 15.9541 88.8248 16.1662C88.571 16.3783 88.2604 16.5545 87.893 16.6946C87.5256 16.8348 87.1013 16.9049 86.6203 16.9049ZM87.1998 15.5412C87.6733 15.5412 88.0918 15.4484 88.4555 15.2628C88.8229 15.0772 89.1203 14.8348 89.3475 14.5355C89.5748 14.2325 89.7168 13.9086 89.7737 13.5639L89.9612 12.4389C89.8892 12.4995 89.7623 12.5545 89.5805 12.6037C89.4024 12.653 89.2017 12.6965 88.9782 12.7344C88.7547 12.7723 88.535 12.8045 88.3191 12.831C88.107 12.8575 87.9309 12.8821 87.7907 12.9049C87.4574 12.9465 87.1449 13.0166 86.8532 13.1151C86.5653 13.2136 86.3248 13.3556 86.1316 13.5412C85.9384 13.723 85.8172 13.9655 85.768 14.2685C85.6998 14.6889 85.8002 15.0071 86.0691 15.223C86.3418 15.4352 86.7187 15.5412 87.1998 15.5412ZM99.221 7.9844L98.9994 9.34803H94.2324L94.4539 7.9844H99.221ZM96.0733 5.89349H97.7721L96.3971 14.1492C96.3441 14.4787 96.3536 14.7268 96.4255 14.8935C96.4975 15.0564 96.6074 15.1681 96.7551 15.2287C96.9066 15.2855 97.0752 15.3139 97.2608 15.3139C97.3971 15.3139 97.5164 15.3045 97.6187 15.2855C97.721 15.2666 97.8024 15.2514 97.863 15.2401L97.9539 16.6435C97.8403 16.6814 97.6869 16.7192 97.4937 16.7571C97.3043 16.7988 97.0733 16.8215 96.8005 16.8253C96.3536 16.8329 95.9502 16.7533 95.5903 16.5867C95.2305 16.4162 94.9615 16.1586 94.7835 15.8139C94.6055 15.4655 94.5619 15.028 94.6528 14.5014L96.0733 5.89349ZM103.748 16.8878C102.918 16.8878 102.225 16.6984 101.668 16.3196C101.112 15.937 100.719 15.403 100.492 14.7174C100.269 14.028 100.231 13.2268 100.379 12.3139C100.522 11.42 100.812 10.6397 101.248 9.97303C101.687 9.30637 102.237 8.78932 102.896 8.4219C103.558 8.05447 104.295 7.87076 105.106 7.87076C105.935 7.87076 106.627 8.06205 107.18 8.44462C107.737 8.8272 108.129 9.36318 108.356 10.0526C108.583 10.742 108.623 11.545 108.475 12.4617C108.331 13.348 108.038 14.1245 107.594 14.7912C107.155 15.4541 106.606 15.9692 105.947 16.3367C105.288 16.7041 104.555 16.8878 103.748 16.8878ZM103.844 15.4617C104.39 15.4617 104.865 15.3177 105.271 15.0299C105.68 14.742 106.013 14.3594 106.271 13.8821C106.528 13.4049 106.704 12.8821 106.799 12.3139C106.886 11.7647 106.884 11.2628 106.793 10.8083C106.706 10.3499 106.517 9.9825 106.225 9.70599C105.933 9.42947 105.528 9.29121 105.009 9.29121C104.464 9.29121 103.985 9.43705 103.572 9.72871C103.163 10.0166 102.829 10.4011 102.572 10.8821C102.318 11.3632 102.146 11.8878 102.055 12.456C101.968 13.0014 101.968 13.5033 102.055 13.9617C102.142 14.4162 102.331 14.7799 102.623 15.0526C102.915 15.3253 103.322 15.4617 103.844 15.4617ZM110.153 16.7117L111.607 7.9844H113.249L113.016 9.37076H113.107C113.342 8.90106 113.685 8.53175 114.136 8.26281C114.586 7.99008 115.067 7.85371 115.579 7.85371C115.689 7.85371 115.814 7.8575 115.954 7.86508C116.094 7.86887 116.208 7.87834 116.295 7.89349L116.022 9.51849C115.958 9.49955 115.84 9.47872 115.67 9.45599C115.499 9.42947 115.323 9.41621 115.141 9.41621C114.743 9.41621 114.374 9.50144 114.033 9.6719C113.692 9.83856 113.406 10.0715 113.175 10.3708C112.944 10.6662 112.795 11.0033 112.726 11.3821L111.851 16.7117H110.153ZM117.61 19.9844C117.352 19.9844 117.123 19.9636 116.922 19.9219C116.722 19.884 116.572 19.8424 116.473 19.7969L117.121 18.4049C117.42 18.4882 117.688 18.5204 117.922 18.5014C118.161 18.4825 118.384 18.384 118.593 18.206C118.801 18.028 119.013 17.7477 119.229 17.3651L119.547 16.7912L117.837 7.9844H119.587L120.667 14.7742H120.758L124.098 7.9844H125.991L120.758 17.8651C120.511 18.3348 120.231 18.7249 119.917 19.0355C119.606 19.3499 119.258 19.5867 118.871 19.7458C118.489 19.9049 118.068 19.9844 117.61 19.9844ZM135.043 16.8878C134.213 16.8878 133.52 16.6984 132.963 16.3196C132.407 15.937 132.014 15.403 131.787 14.7174C131.564 14.028 131.526 13.2268 131.674 12.3139C131.817 11.42 132.107 10.6397 132.543 9.97303C132.982 9.30637 133.532 8.78932 134.191 8.4219C134.853 8.05447 135.59 7.87076 136.401 7.87076C137.23 7.87076 137.922 8.06205 138.475 8.44462C139.032 8.8272 139.424 9.36318 139.651 10.0526C139.878 10.742 139.918 11.545 139.77 12.4617C139.626 13.348 139.333 14.1245 138.889 14.7912C138.45 15.4541 137.901 15.9692 137.242 16.3367C136.583 16.7041 135.85 16.8878 135.043 16.8878ZM135.139 15.4617C135.685 15.4617 136.16 15.3177 136.566 15.0299C136.975 14.742 137.308 14.3594 137.566 13.8821C137.823 13.4049 137.999 12.8821 138.094 12.3139C138.181 11.7647 138.179 11.2628 138.088 10.8083C138.001 10.3499 137.812 9.9825 137.52 9.70599C137.228 9.42947 136.823 9.29121 136.304 9.29121C135.759 9.29121 135.28 9.43705 134.867 9.72871C134.458 10.0166 134.124 10.4011 133.867 10.8821C133.613 11.3632 133.441 11.8878 133.35 12.456C133.263 13.0014 133.263 13.5033 133.35 13.9617C133.437 14.4162 133.626 14.7799 133.918 15.0526C134.21 15.3253 134.617 15.4617 135.139 15.4617ZM147.056 7.9844L146.834 9.34803H141.902L142.124 7.9844H147.056ZM142.021 16.7117L143.646 6.97303C143.73 6.42758 143.921 5.97493 144.22 5.61508C144.52 5.25144 144.881 4.98061 145.306 4.80258C145.73 4.62076 146.173 4.52985 146.635 4.52985C146.976 4.52985 147.262 4.55826 147.493 4.61508C147.728 4.66811 147.898 4.71735 148.004 4.76281L147.385 6.13781C147.309 6.11508 147.213 6.08856 147.095 6.05826C146.978 6.02417 146.83 6.00712 146.652 6.00712C146.239 6.00712 145.927 6.1094 145.715 6.31394C145.506 6.51849 145.366 6.81394 145.294 7.20031L143.72 16.7117H142.021ZM149.095 16.8196C148.777 16.8196 148.512 16.7098 148.3 16.4901C148.091 16.2704 147.989 16.0014 147.993 15.6833C147.997 15.3689 148.114 15.1056 148.345 14.8935C148.58 14.6776 148.853 14.5696 149.163 14.5696C149.474 14.5696 149.739 14.6795 149.959 14.8992C150.179 15.1189 150.281 15.3802 150.266 15.6833C150.254 15.8954 150.194 16.0886 150.084 16.2628C149.978 16.4333 149.838 16.5696 149.663 16.6719C149.489 16.7704 149.3 16.8196 149.095 16.8196ZM150.146 10.4674C149.828 10.4674 149.563 10.3575 149.351 10.1378C149.143 9.91432 149.04 9.64538 149.044 9.33099C149.048 9.01659 149.165 8.75334 149.396 8.54121C149.631 8.32531 149.904 8.21735 150.215 8.21735C150.521 8.21735 150.785 8.3272 151.004 8.5469C151.228 8.76281 151.332 9.02417 151.317 9.33099C151.305 9.53932 151.245 9.73061 151.135 9.90485C151.025 10.0753 150.883 10.2117 150.709 10.3139C150.538 10.4162 150.351 10.4674 150.146 10.4674Z" fill="black"/>
                </svg>
              {/* </div> */}
            </div>
            <div className="pricol d-flex justify-content-center">
              {/* <div className='d-flex justify-content-center'> */}
                <img src="/images/New/ClimateAction100_withNEWTagline.webp" alt="ClimateAction100" className='climate-img mb-4' />
                <img src="/images/New/ClimateAction100_withNEWTagline_WHITE.webp" alt="ClimateAction100" className='climatedark-img mb-4' />
              {/* </div> */}
            </div>
            <div className="pricol d-flex justify-content-center">
              {/* <div className='d-flex justify-content-center'> */}
                <img src="/images/New/CFALogoDark.webp" alt="CFA Logo" className='cfalogo-dark mb-4' />
                <img src="/images/New/CFALogoLight.webp" alt="CFA Logo" className='cfalogo mb-4' />
              {/* </div> */}
            </div>
          </div>
          {/* <div className="mb-4 prilogo desktopView">
            <img src="/images/New/Homepagestatic/pri-logo/PRI-Logo.svg" alt="PRILogo" className="img-fluid priload12" loading='lazy'/>
          </div>
          <div className="mb-4 prilogo mobileView">
            <img src="/images/New/Homepagestatic/pri-logo/PRI-Logo.svg" alt="PRILogo" className="img-fluid priload12" loading='lazy'/>
          </div> */}
        </div>)}
    </div>
  );
};
const mapStateToProps = (state) => ({
  trendingFundData: state.homePage.trendingFundData,
  homepageData: state.homePage.homepageData,
  home: state.homePage,
});

const mapDispatchToProps = (dispatch) => ({
  closePopup: bindActionCreators(closePopup, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
  getTrendingFundData: bindActionCreators(getTrendingFundData, dispatch),
  postSmallCase: bindActionCreators(postSmallCase, dispatch),
  postInvestDataETF: bindActionCreators(postInvestDataETF, dispatch),
  postSmallCaseID: bindActionCreators(postSmallCaseID, dispatch),
  getHomePageDataStatic: bindActionCreators(getHomePageDataStatic, dispatch),
  getHome: bindActionCreators(getHome, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePageNew);
